var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { TranslationTools } from "@gr/translation-tools";
import React, { useRef, useEffect, useContext, memo as memo$1, useMemo } from "react";
var __defProp$2 = Object.defineProperty;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2 = (obj, key, value) => key in obj ? __defProp$2(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1.call(b, prop))
      __defNormalProp$2(a, prop, b[prop]);
  if (__getOwnPropSymbols$1)
    for (var prop of __getOwnPropSymbols$1(b)) {
      if (__propIsEnum$1.call(b, prop))
        __defNormalProp$2(a, prop, b[prop]);
    }
  return a;
};
class BaseException extends Error {
  constructor(error, context) {
    super();
    this.error = error;
    this.context = context;
    this.prepareMessage();
  }
  prepareMessage() {
    const context = this.parseContextToString();
    this.message = context ? `${this.error} (${context})` : this.error;
  }
  parseContextToString() {
    if (this.context) {
      return Object.entries(this.context).map(([key, value]) => typeof value === "undefined" ? void 0 : `${key}: ${value}`).filter(Boolean).join(", ");
    }
    return "";
  }
  appendContext(context) {
    this.context = __spreadValues$1(__spreadValues$1({}, this.context), context);
    this.prepareMessage();
    return this;
  }
}
class ParserException extends BaseException {
  constructor(message, position) {
    super(message, { position });
    this.position = position;
  }
}
var CharCode;
(function(CharCode2) {
  CharCode2[CharCode2["Space"] = 32] = "Space";
  CharCode2[CharCode2["Hash"] = 35] = "Hash";
  CharCode2[CharCode2["Apostrophe"] = 39] = "Apostrophe";
  CharCode2[CharCode2["Comma"] = 44] = "Comma";
  CharCode2[CharCode2["Slash"] = 47] = "Slash";
  CharCode2[CharCode2["LeftAngleBracket"] = 60] = "LeftAngleBracket";
  CharCode2[CharCode2["EqualsSign"] = 61] = "EqualsSign";
  CharCode2[CharCode2["RightAngleBracket"] = 62] = "RightAngleBracket";
  CharCode2[CharCode2["LeftCurlyBracket"] = 123] = "LeftCurlyBracket";
  CharCode2[CharCode2["RightCurlyBracket"] = 125] = "RightCurlyBracket";
})(CharCode || (CharCode = {}));
class MissingChunkException extends ParserException {
  constructor(position) {
    super("Missing chunk", position);
  }
}
function getCodePoint(message, pointer) {
  const char = message.codePointAt(pointer);
  if (typeof char === "undefined") {
    throw new ParserException("Invalid UTF code");
  }
  return char;
}
function hasChar(message, pointer) {
  return pointer < message.length;
}
function getSafeCodePoint(message, pointer) {
  return hasChar(message, pointer) ? getCodePoint(message, pointer) : void 0;
}
function isAlpha(codePoint) {
  return codePoint >= 97 && codePoint <= 122 || codePoint >= 65 && codePoint <= 90;
}
function isAlphaOrSlash(codePoint) {
  return isAlpha(codePoint) || codePoint === CharCode.Slash;
}
var SelectorType;
(function(SelectorType2) {
  SelectorType2["Number"] = "number";
  SelectorType2["Date"] = "date";
  SelectorType2["Time"] = "time";
  SelectorType2["Plural"] = "plural";
  SelectorType2["Select"] = "select";
  SelectorType2["SelectOrdinal"] = "selectordinal";
})(SelectorType || (SelectorType = {}));
function isParentPlural(type) {
  return type === SelectorType.Plural || type === SelectorType.SelectOrdinal;
}
var MessageChunkType;
(function(MessageChunkType2) {
  MessageChunkType2[MessageChunkType2["Literal"] = 0] = "Literal";
  MessageChunkType2[MessageChunkType2["Argument"] = 1] = "Argument";
  MessageChunkType2[MessageChunkType2["Plural"] = 2] = "Plural";
  MessageChunkType2[MessageChunkType2["Number"] = 3] = "Number";
  MessageChunkType2[MessageChunkType2["Select"] = 4] = "Select";
  MessageChunkType2[MessageChunkType2["Tag"] = 5] = "Tag";
  MessageChunkType2[MessageChunkType2["Hash"] = 6] = "Hash";
})(MessageChunkType || (MessageChunkType = {}));
class ClosingBracketException extends ParserException {
  constructor(position) {
    super("Expect closing brackets", position);
  }
}
class MissingIdentifierException extends ParserException {
  constructor(position) {
    super("Missing identifier token", position);
  }
}
var PluralType;
(function(PluralType2) {
  PluralType2["Cardinal"] = "cardinal";
  PluralType2["Ordinal"] = "ordinal";
})(PluralType || (PluralType = {}));
class InvalidArgumentException extends ParserException {
  constructor(position) {
    super("Invalid argument", position);
  }
}
class NotImplementedException extends ParserException {
  constructor(position) {
    super("Not implemented yet", position);
  }
}
const patternSyntax = [
  36,
  40,
  41,
  42,
  43,
  44,
  45,
  91,
  92,
  93,
  94,
  96,
  123,
  124,
  125,
  126,
  161,
  166,
  167,
  169,
  171,
  172,
  174,
  176,
  177,
  182,
  187,
  191,
  215,
  247,
  8216,
  8217,
  8218,
  8221,
  8222,
  8223,
  8249,
  8250,
  8260,
  8261,
  8262,
  8274,
  8275,
  8608,
  8611,
  8614,
  8622,
  8658,
  8659,
  8660,
  8968,
  8969,
  8970,
  8971,
  9001,
  9002,
  9084,
  9655,
  9665,
  9839,
  10088,
  10089,
  10090,
  10091,
  10092,
  10093,
  10094,
  10095,
  10096,
  10097,
  10098,
  10099,
  10100,
  10101,
  10181,
  10182,
  10214,
  10215,
  10216,
  10217,
  10218,
  10219,
  10220,
  10221,
  10222,
  10223,
  10627,
  10628,
  10629,
  10630,
  10631,
  10632,
  10633,
  10634,
  10635,
  10636,
  10637,
  10638,
  10639,
  10640,
  10641,
  10642,
  10643,
  10644,
  10645,
  10646,
  10647,
  10648,
  10712,
  10713,
  10714,
  10715,
  10748,
  10749,
  11158,
  11778,
  11779,
  11780,
  11781,
  11785,
  11786,
  11787,
  11788,
  11789,
  11799,
  11802,
  11803,
  11804,
  11805,
  11808,
  11809,
  11810,
  11811,
  11812,
  11813,
  11814,
  11815,
  11816,
  11817,
  11823,
  11840,
  11841,
  11842,
  11858,
  12296,
  12297,
  12298,
  12299,
  12300,
  12301,
  12302,
  12303,
  12304,
  12305,
  12308,
  12309,
  12310,
  12311,
  12312,
  12313,
  12314,
  12315,
  12316,
  12317,
  12320,
  12336,
  64830,
  64831
];
function isPatternSyntax(codePoint) {
  return patternSyntax.includes(codePoint) || codePoint >= 33 && codePoint <= 35 || codePoint >= 37 && codePoint <= 39 || codePoint >= 46 && codePoint <= 47 || codePoint >= 58 && codePoint <= 59 || codePoint >= 60 && codePoint <= 62 || codePoint >= 63 && codePoint <= 64 || codePoint >= 162 && codePoint <= 165 || codePoint >= 8208 && codePoint <= 8213 || codePoint >= 8214 && codePoint <= 8215 || codePoint >= 8219 && codePoint <= 8220 || codePoint >= 8224 && codePoint <= 8231 || codePoint >= 8240 && codePoint <= 8248 || codePoint >= 8251 && codePoint <= 8254 || codePoint >= 8257 && codePoint <= 8259 || codePoint >= 8263 && codePoint <= 8273 || codePoint >= 8277 && codePoint <= 8286 || codePoint >= 8592 && codePoint <= 8596 || codePoint >= 8597 && codePoint <= 8601 || codePoint >= 8602 && codePoint <= 8603 || codePoint >= 8604 && codePoint <= 8607 || codePoint >= 8609 && codePoint <= 8610 || codePoint >= 8612 && codePoint <= 8613 || codePoint >= 8615 && codePoint <= 8621 || codePoint >= 8623 && codePoint <= 8653 || codePoint >= 8654 && codePoint <= 8655 || codePoint >= 8656 && codePoint <= 8657 || codePoint >= 8661 && codePoint <= 8691 || codePoint >= 8692 && codePoint <= 8959 || codePoint >= 8960 && codePoint <= 8967 || codePoint >= 8972 && codePoint <= 8991 || codePoint >= 8992 && codePoint <= 8993 || codePoint >= 8994 && codePoint <= 9e3 || codePoint >= 9003 && codePoint <= 9083 || codePoint >= 9085 && codePoint <= 9114 || codePoint >= 9115 && codePoint <= 9139 || codePoint >= 9140 && codePoint <= 9179 || codePoint >= 9180 && codePoint <= 9185 || codePoint >= 9186 && codePoint <= 9254 || codePoint >= 9255 && codePoint <= 9279 || codePoint >= 9280 && codePoint <= 9290 || codePoint >= 9291 && codePoint <= 9311 || codePoint >= 9472 && codePoint <= 9654 || codePoint >= 9656 && codePoint <= 9664 || codePoint >= 9666 && codePoint <= 9719 || codePoint >= 9720 && codePoint <= 9727 || codePoint >= 9728 && codePoint <= 9838 || codePoint >= 9840 && codePoint <= 10087 || codePoint >= 10132 && codePoint <= 10175 || codePoint >= 10176 && codePoint <= 10180 || codePoint >= 10183 && codePoint <= 10213 || codePoint >= 10224 && codePoint <= 10239 || codePoint >= 10240 && codePoint <= 10495 || codePoint >= 10496 && codePoint <= 10626 || codePoint >= 10649 && codePoint <= 10711 || codePoint >= 10716 && codePoint <= 10747 || codePoint >= 10750 && codePoint <= 11007 || codePoint >= 11008 && codePoint <= 11055 || codePoint >= 11056 && codePoint <= 11076 || codePoint >= 11077 && codePoint <= 11078 || codePoint >= 11079 && codePoint <= 11084 || codePoint >= 11085 && codePoint <= 11123 || codePoint >= 11124 && codePoint <= 11125 || codePoint >= 11126 && codePoint <= 11157 || codePoint >= 11159 && codePoint <= 11263 || codePoint >= 11776 && codePoint <= 11777 || codePoint >= 11782 && codePoint <= 11784 || codePoint >= 11790 && codePoint <= 11798 || codePoint >= 11800 && codePoint <= 11801 || codePoint >= 11806 && codePoint <= 11807 || codePoint >= 11818 && codePoint <= 11822 || codePoint >= 11824 && codePoint <= 11833 || codePoint >= 11834 && codePoint <= 11835 || codePoint >= 11836 && codePoint <= 11839 || codePoint >= 11843 && codePoint <= 11855 || codePoint >= 11856 && codePoint <= 11857 || codePoint >= 11859 && codePoint <= 11903 || codePoint >= 12289 && codePoint <= 12291 || codePoint >= 12306 && codePoint <= 12307 || codePoint >= 12318 && codePoint <= 12319 || codePoint >= 65093 && codePoint <= 65094;
}
function parseIdentifier(message, offset) {
  let pointer = offset;
  while (hasChar(message, pointer)) {
    const codePoint = getCodePoint(message, pointer);
    if (!codePoint || isPatternSyntax(codePoint)) {
      break;
    } else {
      pointer += 1;
    }
  }
  return {
    value: message.slice(offset, pointer).trim(),
    position: [offset, pointer]
  };
}
function isCodePointComma(message, pointer) {
  return getSafeCodePoint(message, pointer) === CharCode.Comma;
}
class ChunkEmptyException extends ParserException {
  constructor(position) {
    super("Chunk is empty", position);
  }
}
class UnclosedQuoteException extends ParserException {
  constructor(position) {
    super("Unclosed quote", position);
  }
}
function parseNumberStyle(message, offset) {
  let pointer = offset;
  let hasApostrophe = false;
  let bracketLevel = 0;
  while (hasChar(message, pointer) && bracketLevel > -1) {
    const char = getCodePoint(message, pointer);
    if (char === CharCode.Apostrophe) {
      hasApostrophe = !hasApostrophe;
    } else if (!hasApostrophe) {
      if (char === CharCode.LeftCurlyBracket) {
        bracketLevel += 1;
      } else if (char === CharCode.RightCurlyBracket) {
        bracketLevel -= 1;
      }
    }
    pointer += 1;
  }
  if (hasApostrophe) {
    throw new UnclosedQuoteException([offset, pointer]);
  }
  if (bracketLevel > -1) {
    throw new ClosingBracketException([offset, pointer]);
  }
  const value = message.slice(offset, pointer - 1).trim();
  if (!value) {
    throw new ChunkEmptyException([offset, pointer]);
  }
  return {
    value,
    position: [offset, pointer - 1]
  };
}
function parseNumberOptions(message, offset) {
  if (isCodePointComma(message, offset)) {
    return parseNumberStyle(message, offset + 1);
  }
  return {
    value: void 0,
    position: [offset, offset]
  };
}
class ExpectArgumentException extends ParserException {
  constructor(position) {
    super("Expect argument", position);
  }
}
class DuplicateSelectorException extends ParserException {
  constructor(position) {
    super("Duplicate selector", position);
  }
}
class MissingOtherSelectorException extends ParserException {
  constructor(position) {
    super("Missing other selector", position);
  }
}
class OpeningBracketException extends ParserException {
  constructor(position) {
    super("Expect opening brackets", position);
  }
}
function getParseMessagePosition(chunks) {
  const { length } = chunks;
  if (length > 0) {
    return [chunks[0].position[0], chunks[length - 1].position[1]];
  }
  return void 0;
}
const whiteSpace = [32, 133, 8232, 8233];
function isWhiteSpace(codePoint) {
  return whiteSpace.includes(codePoint) || codePoint >= 9 && codePoint <= 13 || codePoint >= 8206 && codePoint <= 8207;
}
function parseSpace(message, offset) {
  let pointer = offset;
  while (hasChar(message, pointer) && isWhiteSpace(getCodePoint(message, pointer))) {
    pointer += 1;
  }
  return [offset, pointer];
}
class InvalidNumberException extends ParserException {
  constructor(position) {
    super("Invalid parsed number", position);
  }
}
class ParseNumberException extends ParserException {
  constructor(position) {
    super("Can not parse number", position);
  }
}
function isCodePointNumber(codePoint) {
  return codePoint >= 48 && codePoint <= 57;
}
function isCodePointSign(codePoint) {
  return codePoint === 45 || codePoint === 43;
}
function tryParseNumber(message, offset) {
  if (!hasChar(message, offset)) {
    throw new ParseNumberException([offset, offset]);
  }
  const code = getCodePoint(message, offset);
  let pointer = isCodePointSign(code) ? offset + 1 : offset;
  while (hasChar(message, pointer)) {
    const codePoint = getCodePoint(message, pointer);
    if (!isCodePointNumber(codePoint)) {
      break;
    }
    pointer += 1;
  }
  const chunk = message.slice(offset, pointer);
  if (!chunk) {
    throw new ParseNumberException([offset, pointer]);
  }
  const value = Number(chunk);
  if (!Number.isSafeInteger(value)) {
    throw new InvalidNumberException([offset, pointer]);
  }
  return {
    value,
    position: [offset, pointer]
  };
}
function parseSelector(message, offset, parent) {
  const selector = parseIdentifier(message, offset);
  if (selector.value) {
    return selector;
  }
  if (parent !== SelectorType.Select) {
    const space = parseSpace(message, offset);
    if (message.startsWith("=", space[1])) {
      const numberChunk = tryParseNumber(message, space[1] + 1);
      return {
        value: `=${numberChunk.value}`,
        position: [offset, numberChunk.position[1]]
      };
    }
  }
  return void 0;
}
function parseSelectors(message, offset, level = 0, parent, shouldClosedTag, shouldHaveOther) {
  const options = [];
  let pointer = offset;
  let space;
  let hasOther = false;
  const selectors = new Set();
  while (hasChar(message, pointer)) {
    const selector = parseSelector(message, pointer, parent);
    if (!selector) {
      break;
    }
    if (selectors.has(selector.value)) {
      throw new DuplicateSelectorException(selector.position);
    }
    selectors.add(selector.value);
    if (selector.value === "other") {
      hasOther = true;
    }
    space = parseSpace(message, selector.position[1]);
    if (getSafeCodePoint(message, space[1]) !== CharCode.LeftCurlyBracket) {
      throw new OpeningBracketException(space);
    }
    const content = parseMessage(message, space[1] + 1, level + 1, parent, shouldClosedTag);
    const parsedPosition = getParseMessagePosition(content);
    space = parseSpace(message, parsedPosition ? parsedPosition[1] : space[1] + 1);
    if (getSafeCodePoint(message, space[1]) !== CharCode.RightCurlyBracket) {
      throw new ClosingBracketException(space);
    }
    options.push([selector.value, content]);
    pointer = space[1] + 1;
  }
  space = parseSpace(message, pointer);
  if (getSafeCodePoint(message, space[1]) !== CharCode.RightCurlyBracket) {
    throw new ClosingBracketException(space);
  }
  if (options.length === 0) {
    throw new ExpectArgumentException([offset, pointer]);
  }
  if (!hasOther && shouldHaveOther) {
    throw new MissingOtherSelectorException([offset, pointer]);
  }
  return {
    value: options,
    position: [offset, space[1] + 1]
  };
}
function parsePluralOptions(message, offset, level = 0, parent, shouldClosedTag) {
  if (!isCodePointComma(message, offset)) {
    throw new ExpectArgumentException([offset, offset]);
  }
  const { value, position } = parseSelectors(message, offset + 1, level, parent, shouldClosedTag, false);
  return {
    value: Object.fromEntries(value),
    position: [offset, position[1]]
  };
}
function parseArgumentType(message, offset, value, level = 0, parent, shouldClosedTag) {
  const argumentType = parseIdentifier(message, offset + 1);
  const pointer = argumentType.position[1];
  switch (argumentType.value) {
    case SelectorType.Number:
      const options = parseNumberOptions(message, pointer);
      return {
        type: MessageChunkType.Number,
        value,
        position: [offset, options.position[1] + 1],
        options: options.value
      };
    case SelectorType.Plural:
    case SelectorType.SelectOrdinal:
      const pluralOptions = parsePluralOptions(message, pointer, level, argumentType.value, shouldClosedTag);
      return {
        type: MessageChunkType.Plural,
        value,
        position: [offset, pluralOptions.position[1]],
        options: pluralOptions.value,
        pluralType: argumentType.value === SelectorType.Plural ? PluralType.Cardinal : PluralType.Ordinal
      };
    case SelectorType.Select:
      const selectOptions = parsePluralOptions(message, pointer, level, argumentType.value, shouldClosedTag);
      return {
        type: MessageChunkType.Select,
        value,
        position: [offset, selectOptions.position[1]],
        options: selectOptions.value
      };
    case SelectorType.Date:
    case SelectorType.Time:
      throw new NotImplementedException(argumentType.position);
    default:
      throw new InvalidArgumentException(argumentType.position);
  }
}
function parseArgument(message, offset, level = 0, parent, shouldClosedTag) {
  const token = parseIdentifier(message, offset + 1);
  if (!token.value) {
    throw new MissingIdentifierException();
  }
  const pointer = token.position[1];
  if (!hasChar(message, pointer)) {
    throw new ClosingBracketException();
  }
  const nextChar = getCodePoint(message, pointer);
  if (nextChar === CharCode.RightCurlyBracket) {
    return {
      type: MessageChunkType.Argument,
      value: token.value,
      position: [offset, pointer + 1]
    };
  }
  if (nextChar === CharCode.Comma) {
    return parseArgumentType(message, pointer, token.value, level, parent, shouldClosedTag);
  }
  throw new ClosingBracketException();
}
function parseHash(offset) {
  return {
    type: MessageChunkType.Hash,
    position: [offset, offset + 1]
  };
}
const SpecialChars = [CharCode.LeftCurlyBracket, CharCode.RightCurlyBracket, CharCode.RightAngleBracket];
function parseLiteralQuote(message, offset, parent) {
  let pointer = offset + 1;
  const codePoint = getSafeCodePoint(message, pointer);
  if (codePoint === CharCode.Apostrophe) {
    return {
      value: [codePoint],
      position: [offset, pointer]
    };
  }
  if (!codePoint || !SpecialChars.includes(codePoint) || codePoint === CharCode.Hash && !isParentPlural(parent) || message.startsWith("</", pointer)) {
    return void 0;
  }
  pointer += 1;
  let shouldCheck = true;
  const value = [CharCode.Apostrophe, codePoint];
  while (hasChar(message, pointer) && shouldCheck) {
    const nextCodePoint = getCodePoint(message, pointer);
    if (nextCodePoint === CharCode.Apostrophe) {
      if (getSafeCodePoint(message, pointer + 1) === CharCode.Apostrophe) {
        pointer += 1;
      }
      shouldCheck = false;
    } else {
      pointer += 1;
    }
    value.push(nextCodePoint);
  }
  return {
    value,
    position: [offset, pointer]
  };
}
function parseLiteral(message, offset, level = 0, parent) {
  var _a;
  const value = [];
  let pointer = offset;
  while (hasChar(message, pointer)) {
    const codePoint = getCodePoint(message, pointer);
    let chunk;
    if (codePoint === CharCode.Apostrophe) {
      chunk = parseLiteralQuote(message, pointer, parent);
    }
    if (!chunk && (codePoint === CharCode.LeftCurlyBracket || codePoint === CharCode.Hash && isParentPlural(parent) || level > 0 && codePoint === CharCode.RightCurlyBracket || codePoint === CharCode.LeftAngleBracket && isAlphaOrSlash((_a = getSafeCodePoint(message, pointer + 1)) != null ? _a : 0))) {
      break;
    }
    if (chunk) {
      value.push(...chunk.value);
      pointer = chunk.position[1] + 1;
    } else {
      value.push(codePoint);
      pointer += 1;
    }
  }
  return {
    type: MessageChunkType.Literal,
    value: String.fromCodePoint(...value),
    position: [offset, pointer]
  };
}
class InvalidClosedTagException extends ParserException {
  constructor(position) {
    super("Invalid closed tag", position);
  }
}
class InvalidTagException extends ParserException {
  constructor(position) {
    super("Invalid tag", position);
  }
}
class MissingClosedTagException extends ParserException {
  constructor(position) {
    super("Missing closed tag", position);
  }
}
function isTagNameSyntax(codePoint) {
  return isAlpha(codePoint) || codePoint === 45 || codePoint === 46 || codePoint >= 48 && codePoint <= 57 || codePoint === 95 || codePoint === 183 || codePoint >= 192 && codePoint <= 214 || codePoint >= 216 && codePoint <= 246 || codePoint >= 248 && codePoint <= 893 || codePoint >= 895 && codePoint <= 8191 || codePoint >= 8204 && codePoint <= 8205 || codePoint >= 8255 && codePoint <= 8256 || codePoint >= 8304 && codePoint <= 8591 || codePoint >= 11264 && codePoint <= 12271 || codePoint >= 12289 && codePoint <= 55295 || codePoint >= 63744 && codePoint <= 64975 || codePoint >= 65008 && codePoint <= 65533 || codePoint >= 65536 && codePoint <= 983039;
}
function parseTagName(message, offset) {
  let pointer = offset;
  while (hasChar(message, pointer) && isTagNameSyntax(getCodePoint(message, pointer))) {
    pointer += 1;
  }
  return {
    value: message.slice(offset, pointer),
    position: [offset, pointer]
  };
}
const tagsWithoutNeedClosed = [
  "area",
  "base",
  "br",
  "col",
  "embed",
  "hr",
  "img",
  "input",
  "link",
  "meta",
  "param",
  "source",
  "track",
  "wbr"
];
const whiteTags = ["br"];
function parseTag(message, offset, level = 0, parent) {
  const hasSlash = message.startsWith("/", offset + 1);
  const beginTagName = parseTagName(message, offset + (hasSlash ? 2 : 1));
  let position = parseSpace(message, beginTagName.position[1]);
  if (hasSlash && !whiteTags.includes(beginTagName.value)) {
    throw new InvalidTagException([offset, position[1]]);
  }
  if (tagsWithoutNeedClosed.includes(beginTagName.value) && message.startsWith(">", position[1])) {
    return { type: MessageChunkType.Tag, value: beginTagName.value, position: [offset, position[1] + 1], children: [], closed: true };
  }
  if (message.startsWith("/>", position[1])) {
    return { type: MessageChunkType.Tag, value: beginTagName.value, position: [offset, position[1] + 2], children: [], closed: true };
  }
  if (getCodePoint(message, position[1]) !== CharCode.RightAngleBracket) {
    throw new InvalidTagException([offset, position[1]]);
  }
  const children = parseMessage(message, position[1] + 1, level + 1, parent, true);
  const parsedPosition = getParseMessagePosition(children);
  const pointer = parsedPosition ? parsedPosition[1] : position[1] + 1;
  if (!message.startsWith("</", pointer)) {
    throw new MissingClosedTagException([offset, pointer]);
  }
  const endTagName = parseTagName(message, pointer + 2);
  if (beginTagName.value !== endTagName.value) {
    throw new InvalidClosedTagException(endTagName.position);
  }
  position = parseSpace(message, endTagName.position[1]);
  if (getCodePoint(message, position[1]) !== CharCode.RightAngleBracket) {
    throw new InvalidTagException([offset, position[1]]);
  }
  return {
    type: MessageChunkType.Tag,
    value: beginTagName.value,
    position: [offset, position[1] + 1],
    children
  };
}
function parseMessage(message, offset = 0, level = 0, parent, shouldClosedTag) {
  var _a;
  const chunks = [];
  let pointer = offset;
  while (hasChar(message, pointer)) {
    let chunk;
    const char = getCodePoint(message, pointer);
    if (char === CharCode.LeftCurlyBracket) {
      chunk = parseArgument(message, pointer, level, parent, shouldClosedTag);
    } else if (char === CharCode.RightCurlyBracket && level > 0) {
      break;
    } else if (char === CharCode.Hash && isParentPlural(parent)) {
      chunk = parseHash(pointer);
    } else if (char === CharCode.LeftAngleBracket && shouldClosedTag && getSafeCodePoint(message, pointer + 1) === CharCode.Slash) {
      break;
    } else if (char === CharCode.LeftAngleBracket && isAlphaOrSlash((_a = getSafeCodePoint(message, pointer + 1)) != null ? _a : 0)) {
      chunk = parseTag(message, pointer, level, parent);
    } else {
      chunk = parseLiteral(message, pointer, level, parent);
    }
    if (chunk) {
      chunks.push(chunk);
      pointer = chunk.position[1];
    } else {
      throw new MissingChunkException([offset, pointer]);
    }
  }
  return chunks;
}
function parse(message) {
  return message ? parseMessage(message) : [];
}
var FormatChunk;
(function(FormatChunk2) {
  FormatChunk2[FormatChunk2["Literal"] = 0] = "Literal";
  FormatChunk2[FormatChunk2["Object"] = 1] = "Object";
})(FormatChunk || (FormatChunk = {}));
class FormatException extends BaseException {
}
class MissingPropertyFormatException extends FormatException {
  constructor(propertyName) {
    super("Missing property in passed values", { propertyName });
  }
}
function getValue(chunk, values) {
  if (values && chunk.value && chunk.value in values) {
    return values[chunk.value];
  }
  throw new MissingPropertyFormatException(chunk.value);
}
class TagFunctionFormatException extends FormatException {
  constructor(tagName) {
    super("Tag must be declared as function in passed values", { tagName });
  }
}
function mergeFormatChunk(chunks) {
  return chunks.reduce((result, chunk) => {
    const last = result[result.length - 1];
    if (!last || last.type !== FormatChunk.Literal || chunk.type !== FormatChunk.Literal) {
      result.push(chunk);
    } else {
      last.value += chunk.value;
    }
    return result;
  }, []);
}
class InvalidChunkValueFormatException extends FormatException {
  constructor(chunkName) {
    super("Invalid chunk value", { chunkName });
  }
}
class MissingOtherSelectorFormatException extends FormatException {
  constructor(propertyName) {
    super("Missing other selector", { propertyName });
  }
}
function handleWarning(exception) {
  console.warn(exception);
}
const numberOptions = {
  percent: { style: "percent" }
};
function getNumberOptions(type) {
  return type ? numberOptions[type] : void 0;
}
function formatChunks(intl, chunks, values, onWarning = handleWarning, currentValue) {
  var _a, _b, _c;
  const result = [];
  for (const chunk of chunks) {
    switch (chunk.type) {
      case MessageChunkType.Literal:
        result.push({ type: FormatChunk.Literal, value: (_a = chunk.value) != null ? _a : "" });
        break;
      case MessageChunkType.Hash:
        if (typeof currentValue === "number") {
          result.push({ type: FormatChunk.Literal, value: intl.formatNumber().format(currentValue) });
        }
        break;
      case MessageChunkType.Argument:
        const argumentValue = getValue(chunk, values);
        const argumentTransformedValue = typeof argumentValue === "number" ? String(argumentValue) : argumentValue || "";
        result.push({
          type: typeof argumentTransformedValue === "string" ? FormatChunk.Literal : FormatChunk.Object,
          value: argumentTransformedValue
        });
        break;
      case MessageChunkType.Number:
        const numberValue = getValue(chunk, values);
        result.push({ type: FormatChunk.Literal, value: intl.formatNumber(getNumberOptions(chunk.options)).format(numberValue) });
        break;
      case MessageChunkType.Tag:
        const tagValue = getValue(chunk, values);
        if (chunk.closed) {
          if (typeof tagValue === "object") {
            result.push({ type: FormatChunk.Object, value: tagValue });
          } else {
            result.push({ type: FormatChunk.Literal, value: `<${chunk.value}/>` });
          }
          break;
        }
        if (typeof tagValue !== "function") {
          throw new TagFunctionFormatException(chunk.value);
        }
        const parts = formatChunks(intl, (_b = chunk.children) != null ? _b : [], values, onWarning, currentValue);
        const tagResult = tagValue(parts.map((p) => p.value));
        result.push(...(Array.isArray(tagResult) ? tagResult : [tagResult]).map((tag) => ({
          type: typeof tag === "string" ? FormatChunk.Literal : FormatChunk.Object,
          value: tag
        })));
        break;
      case MessageChunkType.Select:
        const selectValue = getValue(chunk, values);
        const selectOption = chunk.options[selectValue] || chunk.options.other;
        if (typeof chunk.options.other === "undefined") {
          onWarning(new MissingOtherSelectorFormatException(chunk.value));
        }
        if (!selectOption) {
          throw new InvalidChunkValueFormatException(chunk.value);
        }
        result.push(...formatChunks(intl, selectOption, values, onWarning, currentValue));
        break;
      case MessageChunkType.Plural:
        const pluralValue = getValue(chunk, values);
        let pluralOption = chunk.options[`=${pluralValue}`];
        if (typeof chunk.options.other === "undefined") {
          onWarning(new MissingOtherSelectorFormatException(chunk.value));
        }
        if (!pluralOption) {
          const pluralRule = intl.formatPlural().select(pluralValue);
          pluralOption = (_c = chunk.options[pluralRule]) != null ? _c : chunk.options.other;
        }
        result.push(...formatChunks(intl, pluralOption, values, onWarning, pluralValue));
        break;
    }
  }
  return mergeFormatChunk(result);
}
const PredefinedEmptyObject = {};
const PredefinedEmptyString = "";
function formatMessageChunk(intl, message, values, onWarning) {
  var _a, _b;
  const chunks = formatChunks(intl, message, values != null ? values : PredefinedEmptyObject, onWarning);
  if (chunks.length < 2) {
    return (_b = (_a = chunks[0]) == null ? void 0 : _a.value) != null ? _b : PredefinedEmptyString;
  }
  return chunks.map((chunk) => chunk.value);
}
const defaultSerialize = (...args) => args[0];
function memo(fn, serialize = defaultSerialize) {
  const cache = new Map();
  return (...args) => {
    const key = serialize(args);
    const entry = cache.get(key);
    if (entry) {
      return entry;
    }
    const value = fn(...args);
    cache.set(key, value);
    return value;
  };
}
function createIntl(intlOptions) {
  if (!intlOptions.locale) {
    throw new FormatException("Missing locale in options!");
  }
  return {
    formatNumber: memo((options) => new Intl.NumberFormat(intlOptions.locale, options)),
    formatPlural: memo((options) => new Intl.PluralRules(intlOptions.locale, options)),
    formatDateTime: memo((options) => new Intl.DateTimeFormat(intlOptions.locale, options))
  };
}
var __defProp$1 = Object.defineProperty;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField2 = (obj, key, value) => {
  __defNormalProp$1(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class IntlException extends BaseException {
}
class MissingTranslationIntlException extends IntlException {
  constructor(context) {
    super("Missing translation key in provided messages", context);
  }
}
class Store {
  constructor() {
    __publicField2(this, "store", Object.create(null));
  }
  get(key) {
    return this.store[key];
  }
  set(key, value) {
    this.store[key] = value;
  }
  clear() {
    this.store = Object.create(null);
  }
  clearKey(key) {
    if (this.store[key]) {
      this.store[key] = void 0;
    }
  }
}
class IntlLogger {
  constructor(shouldPrintExceptionInConsole) {
    __publicField2(this, "printedExceptions", new Set());
    __publicField2(this, "shouldPrintExceptionInConsole");
    this.shouldPrintExceptionInConsole = shouldPrintExceptionInConsole != null ? shouldPrintExceptionInConsole : true;
  }
  log(exception) {
    if (this.shouldPrintExceptionInConsole) {
      console.log(exception);
    }
  }
  warn(exception) {
    if (this.shouldPrintExceptionInConsole) {
      console.warn(exception);
    }
  }
  error(exception) {
    if (this.shouldPrintExceptionInConsole && this.shouldPrintException(exception)) {
      console.warn(exception);
    }
  }
  clear() {
    this.printedExceptions.clear();
  }
  shouldPrintException(exception) {
    var _a;
    const id = exception instanceof BaseException ? (_a = exception.context) == null ? void 0 : _a.id : void 0;
    if (typeof id === "string") {
      if (this.printedExceptions.has(id)) {
        return false;
      }
      this.printedExceptions.add(id);
    }
    return true;
  }
}
function tryAppendContext(exception, context) {
  if (exception instanceof BaseException) {
    exception.appendContext(context);
  }
  return exception;
}
class IntlService {
  constructor(options) {
    __publicField2(this, "intlCache");
    __publicField2(this, "messages", Object.create(null));
    __publicField2(this, "messageCache");
    __publicField2(this, "logger");
    var _a, _b;
    if (!options.locale) {
      throw new IntlException("Locale must be provided in options in IntlService");
    }
    this.messageCache = (_a = options.messageCache) != null ? _a : new Store();
    this.logger = (_b = options.logger) != null ? _b : new IntlLogger();
    if (options.messages) {
      this.setMessages(options.messages);
    }
    this.intlCache = createIntl({ locale: options.locale });
  }
  setMessages(messages) {
    Object.assign(this.messages, messages);
    Object.keys(messages).forEach((key) => {
      this.messageCache.clearKey(key);
    });
    return this;
  }
  formatMessage(id, values) {
    var _a;
    const parsedId = String(id);
    const message = this.getMessageChunk(parsedId, values);
    if (typeof message === "string") {
      return message;
    }
    try {
      return formatMessageChunk(this.intlCache, message, values, (exception) => this.logger.warn(tryAppendContext(exception, { id })));
    } catch (error) {
      this.logger.error(tryAppendContext(error, { id }));
    }
    return (_a = this.messages[parsedId]) != null ? _a : parsedId;
  }
  getMessageChunk(id, values) {
    const cacheElement = this.messageCache.get(id);
    if (cacheElement && !(cacheElement instanceof ParserException)) {
      return cacheElement;
    }
    const message = this.messages[id];
    if (typeof message === "string") {
      const parsedMessage = values ? this.parseMessage(id, message) : message.replace(/'\{(.*?)\}'/gi, "{$1}");
      this.messageCache.set(id, parsedMessage);
      if (parsedMessage instanceof ParserException) {
        return message;
      }
      return parsedMessage;
    }
    this.logger.error(new MissingTranslationIntlException({ id }));
    return id;
  }
  parseMessage(id, message) {
    try {
      return parse(message);
    } catch (error) {
      this.logger.error(tryAppendContext(error, { id }));
      return error;
    }
  }
}
var __defProp2 = Object.defineProperty;
var __getOwnPropSymbols2 = Object.getOwnPropertySymbols;
var __hasOwnProp2 = Object.prototype.hasOwnProperty;
var __propIsEnum2 = Object.prototype.propertyIsEnumerable;
var __defNormalProp2 = (obj, key, value) => key in obj ? __defProp2(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues2 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp2.call(b, prop))
      __defNormalProp2(a, prop, b[prop]);
  if (__getOwnPropSymbols2)
    for (var prop of __getOwnPropSymbols2(b)) {
      if (__propIsEnum2.call(b, prop))
        __defNormalProp2(a, prop, b[prop]);
    }
  return a;
};
function isServer() {
  return typeof window === "undefined";
}
function initDB(options) {
  return new Promise((resolve, reject) => {
    const db = indexedDB.open(options.storageName);
    db.onerror = () => reject(db.error);
    db.onupgradeneeded = () => db.result.createObjectStore(options.storageStoreName);
    db.onsuccess = () => {
      resolve(db.result);
    };
  });
}
async function tryToInitDb(...args) {
  if (isServer()) {
    return null;
  }
  try {
    return await initDB(...args);
  } catch (ex) {
    console.warn("Failed to open translations DB", ex);
  }
  return null;
}
async function getSpace(locale, space, options) {
  const db = await tryToInitDb(options);
  if (db === null) {
    return {};
  }
  return new Promise((resolve, reject) => {
    const transaction = db.transaction(options.storageStoreName, "readonly").objectStore(options.storageStoreName);
    const keys = transaction.get(`${locale}.${space}`);
    keys.onerror = () => reject(keys.error);
    keys.onsuccess = () => resolve(keys.result);
  });
}
async function getSpaces(locale, spaces, options) {
  const translations = {};
  await Promise.all(spaces.map(async (space) => {
    const keys = await getSpace(locale, space, options);
    if (keys !== null) {
      translations[space] = keys;
    }
  }));
  return translations;
}
async function setSpace(locale, space, values, options) {
  const db = await tryToInitDb(options);
  if (db === null) {
    return;
  }
  return new Promise((resolve, reject) => {
    const transaction = db.transaction(options.storageStoreName, "readwrite").objectStore(options.storageStoreName);
    const keys = transaction.put(values, `${locale}.${space}`);
    keys.onerror = () => reject(keys.error);
    keys.onsuccess = () => resolve();
  });
}
class SpaceParser {
  constructor(value) {
    __publicField(this, "project");
    __publicField(this, "version");
    __publicField(this, "space");
    const arr = value.split(".");
    if (arr.length === 2) {
      this.project = arr[0];
      this.space = arr[1];
    } else if (arr.length === 3) {
      this.project = arr[0];
      this.version = arr[1];
      this.space = arr[2];
    } else {
      this.space = value;
    }
  }
  setVersion(projects) {
    if (projects) {
      this.version = projects.get(this.project);
    }
    return this;
  }
  getSpace() {
    return this.space;
  }
  getProject() {
    return this.project;
  }
  getVersion() {
    var _a;
    return (_a = this.version) != null ? _a : null;
  }
  getKeyWithoutVersion() {
    return [this.project, this.space].filter(Boolean).join(".");
  }
  getKey() {
    return [this.project, this.version, this.space].filter(Boolean).join(".");
  }
}
class TranslationToolsService$1 {
  static getLists() {
    var _a2;
    var _a, _b;
    return (_a2 = (_b = (_a = globalThis.TranslationTools) == null ? void 0 : _a.Versions) == null ? void 0 : _b.list) != null ? _a2 : void 0;
  }
  static registerSpaceInfo(spaceInfo) {
    var _a, _b;
    (_b = (_a = globalThis.TranslationTools) == null ? void 0 : _a.Overlay) == null ? void 0 : _b.registerSpaceInfo(spaceInfo);
  }
}
async function getETag(spaces, locale, modernProvider, storageConfig, versions) {
  var _a;
  if (!((_a = globalThis.crypto) == null ? void 0 : _a.subtle)) {
    return {
      keys: {},
      value: "bf21a9e8fbc5a3846fb05b4fa0859e0917b2202f"
    };
  }
  const spacesWithVersion = modernProvider ? spaces.map((space) => {
    const parsedSpace = new SpaceParser(space).setVersion(versions);
    TranslationToolsService$1.registerSpaceInfo(parsedSpace);
    return parsedSpace.getKey();
  }) : spaces;
  const cachedTranslations = await getSpaces(locale, spacesWithVersion, storageConfig);
  const flatPairTranslations = Object.values(cachedTranslations).reduce((prev, curr) => __spreadValues2(__spreadValues2({}, prev), curr), {});
  const sortedTranslationKeys = sortKeys(Object.keys(flatPairTranslations), !modernProvider);
  const json = JSON.stringify(flatPairTranslations, sortedTranslationKeys);
  const input = new TextEncoder().encode(modernProvider ? unescapeString(json) : json);
  const hash = await crypto.subtle.digest("SHA-1", input);
  const hashArray = Array.from(new Uint8Array(hash));
  return {
    value: hashArray.map((b) => b.toString(16).padStart(2, "0")).join(""),
    keys: cachedTranslations
  };
}
function sortKeys(keys, caseSensitive) {
  if (caseSensitive) {
    return Array.from(keys).sort();
  }
  const originalKeysMap = new Map();
  return keys.map((k) => {
    const uppercase = k.toUpperCase();
    originalKeysMap.set(uppercase, k);
    return uppercase;
  }).sort().map((k) => originalKeysMap.get(k));
}
function unescapeString(text) {
  return text.replace(/\\u(.{4})/g, (_, hex) => String.fromCodePoint(Number.parseInt(hex, 16)));
}
function splitTranslations(keys = {}) {
  const spaces = {};
  Object.entries(keys).forEach(([key, value]) => {
    const space = key.split(".")[0];
    if (!spaces.hasOwnProperty(space)) {
      spaces[space] = {};
    }
    spaces[space][key] = value;
  });
  return spaces;
}
async function loadTranslations(spaces, locale, options) {
  let eTag = null;
  const versions = TranslationToolsService$1.getLists();
  if (options.useETag) {
    eTag = await getETag(spaces, locale, options.modernProvider, options.storageConfig, versions);
  }
  const response = await fetch(`${options.url}?${buildQuery(options.queryTransformer, locale, spaces)}`, {
    method: "GET",
    headers: __spreadValues2(__spreadValues2(__spreadValues2({}, options.defaultHeaders), eTag && { [options.eTagHeaderName]: eTag.value }), options.modernProvider && (versions == null ? void 0 : versions.size) && buildVersionsHeader(versions))
  });
  if (response.status === 304) {
    if (eTag) {
      return eTag.keys;
    }
    throw new Error("Failed resolving eTag.");
  }
  const responseData = await response.json();
  const translationKeys = options.payloadTransformer ? options.payloadTransformer(responseData, { spaces, locale, eTag: options.useETag }) : responseData;
  const fetchedTranslations = splitTranslations(translationKeys);
  Object.entries(fetchedTranslations).forEach(([space, translations]) => {
    let dbKey = space;
    if (options.modernProvider && versions) {
      const spaceWithProjectName = spaces.find((s) => new SpaceParser(s).getSpace() === space);
      if (spaceWithProjectName) {
        const parsedSpace = new SpaceParser(spaceWithProjectName).setVersion(versions);
        TranslationToolsService$1.registerSpaceInfo(parsedSpace);
        dbKey = parsedSpace.getKey();
      }
    }
    setSpace(locale, dbKey, translations, options.storageConfig);
  });
  return fetchedTranslations;
}
function buildQuery(queryTransformer, locale, spaces) {
  return Object.entries(queryTransformer(locale, spaces)).reduce((prev, curr) => `${prev}${encodeURIComponent(curr[0])}=${encodeURIComponent(curr[1])}&`, "").slice(0, -1);
}
function buildVersionsHeader(versions) {
  return {
    "Translation-Version": [...versions].reduce((acc, [project, version]) => `${acc}${project}:${version},`, "").slice(0, -1)
  };
}
class TranslationsApi {
  constructor(config) {
    __publicField(this, "config");
    this.config = config;
  }
  fetch(data) {
    const { locale, spaces, eTag } = data;
    return loadTranslations(spaces, locale, __spreadProps(__spreadValues({}, this.config), { useETag: eTag }));
  }
}
var EventType;
(function(EventType2) {
  EventType2["INTL_CHANGE"] = "intl";
})(EventType || (EventType = {}));
var CurrencyDisplay;
(function(CurrencyDisplay2) {
  CurrencyDisplay2["SYMBOL"] = "symbol";
  CurrencyDisplay2["CODE"] = "code";
})(CurrencyDisplay || (CurrencyDisplay = {}));
var DateFormat;
(function(DateFormat2) {
  DateFormat2["FULL_DATE"] = "LL";
  DateFormat2["FULL_DATE_SHORT"] = "ll";
  DateFormat2["FULL_DATE_WITH_TIME"] = "LLL";
  DateFormat2["FULL_DATE_WITH_FULL_TIME"] = "DD MMMM YYYY, HH:mm:ss";
  DateFormat2["FULL_DATE_WITH_TIME_SHORT"] = "lll";
  DateFormat2["DATE_NUMERAL"] = "L";
  DateFormat2["TIME"] = "LT";
  DateFormat2["TIME_WITH_SECONDS"] = "LTS";
  DateFormat2["FULL_DATE_SHORT_WITH_TIME"] = "ll LT";
  DateFormat2["MONTH_ONLY"] = "MMMM";
  DateFormat2["MONTH_ONLY_SHORT"] = "MMM";
  DateFormat2["DAY_ONLY"] = "D";
  DateFormat2["MONTH_AND_DAY"] = "MMMM D";
  DateFormat2["MONTH_AND_DAY_SHORT"] = "MMM D";
  DateFormat2["MONTH_AND_DAY_AND_TIME"] = "MMM D LTS";
  DateFormat2["YEAR_AND_MONTH"] = "MMMM Y";
  DateFormat2["YEAR_AND_MONTH_SHORT"] = "MMM Y";
  DateFormat2["DAY_NAME"] = "dddd";
  DateFormat2["FULL_YEAR"] = "YYYY";
})(DateFormat || (DateFormat = {}));
const isDevelopment = false;
const dateFormatMap = {
  [DateFormat.FULL_DATE]: {
    dateStyle: "long"
  },
  [DateFormat.FULL_DATE_SHORT]: {
    dateStyle: "medium"
  },
  [DateFormat.FULL_DATE_WITH_TIME]: {
    dateStyle: "long",
    timeStyle: "short"
  },
  [DateFormat.FULL_DATE_WITH_TIME_SHORT]: {
    dateStyle: "medium",
    timeStyle: "short"
  },
  [DateFormat.FULL_DATE_WITH_FULL_TIME]: {
    dateStyle: "long",
    timeStyle: "medium"
  },
  [DateFormat.DATE_NUMERAL]: {
    dateStyle: "short"
  },
  [DateFormat.TIME]: {
    timeStyle: "short"
  },
  [DateFormat.TIME_WITH_SECONDS]: {
    timeStyle: "medium"
  },
  [DateFormat.FULL_DATE_SHORT_WITH_TIME]: {
    dateStyle: "medium",
    timeStyle: "short"
  },
  [DateFormat.MONTH_ONLY]: {
    month: "long"
  },
  [DateFormat.MONTH_ONLY_SHORT]: {
    month: "short"
  },
  [DateFormat.DAY_ONLY]: {
    day: "numeric"
  },
  [DateFormat.MONTH_AND_DAY]: {
    month: "long",
    day: "numeric"
  },
  [DateFormat.MONTH_AND_DAY_SHORT]: {
    month: "short",
    day: "numeric"
  },
  [DateFormat.MONTH_AND_DAY_AND_TIME]: {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric"
  },
  [DateFormat.YEAR_AND_MONTH]: {
    month: "long",
    year: "numeric"
  },
  [DateFormat.YEAR_AND_MONTH_SHORT]: {
    month: "short",
    year: "numeric"
  },
  [DateFormat.DAY_NAME]: {
    weekday: "long"
  },
  [DateFormat.FULL_YEAR]: {
    year: "numeric"
  }
};
function dateFormatConverter(dateFormat, timeZone) {
  if (timeZone) {
    return __spreadProps(__spreadValues({}, dateFormatMap[dateFormat]), {
      timeZone
    });
  }
  return dateFormatMap[dateFormat];
}
const grLocaleToBcpLocaleMap = {
  br: "pt-br",
  da: "da-dk",
  de: "de-de",
  en: "en-us",
  es: "es-es",
  fr: "fr-fr",
  gb: "en-gb",
  hu: "hu-hu",
  id: "id-id",
  it: "it-it",
  ja: "jp-jp",
  ko: "ko-kr",
  ms: "ms",
  nl: "nl-nl",
  no: "no-no",
  pl: "pl-pl",
  pt: "pt-pt",
  ro: "ro-ro",
  ru: "ru-ru",
  sv: "sv-se",
  th: "th-th",
  tr: "tr-tr",
  vi: "vi",
  zh: "zh-cn",
  ie: "en-ie",
  mx: "es-mx"
};
function convertGrLocaleToBcpLocale(grLocale) {
  return grLocaleToBcpLocaleMap[grLocale] || grLocale;
}
function convertGrLocaleToBcpOrFallbackToDefault(grLocale) {
  return grLocaleToBcpLocaleMap[grLocale] || grLocaleToBcpLocaleMap.en;
}
const bcpLocaleToGrLocaleMap = Object.entries(grLocaleToBcpLocaleMap).reduce((obj, [key, value]) => __spreadProps(__spreadValues({}, obj), { [value]: key }), {});
function convertBcpLocaleToGrLocale(bcpLocale) {
  var _a, _b;
  const lowercaseLocale = bcpLocale.toLowerCase();
  return (_b = (_a = bcpLocaleToGrLocaleMap[lowercaseLocale]) != null ? _a : bcpLocaleToGrLocaleMap[`${lowercaseLocale}-${lowercaseLocale}`]) != null ? _b : null;
}
var NumberFormat;
(function(NumberFormat2) {
  NumberFormat2["SHORT_FORMAT"] = "0.[00]";
  NumberFormat2["ShortFormat"] = "0.[00]";
  NumberFormat2["ShortCompactFormat"] = "0.[00]a";
  NumberFormat2["PERCENTAGE_FORMAT"] = "0.[00]%";
  NumberFormat2["PercentageFormat"] = "0.[00]%";
  NumberFormat2["ROUND_PERCENTAGE_FORMAT"] = "0%";
  NumberFormat2["RoundPercentageFormat"] = "0%";
})(NumberFormat || (NumberFormat = {}));
const numberFormatMap = {
  [NumberFormat.ShortCompactFormat]: {
    maximumFractionDigits: 2,
    notation: "compact"
  },
  [NumberFormat.ShortFormat]: {
    maximumFractionDigits: 2
  },
  [NumberFormat.PercentageFormat]: {
    maximumFractionDigits: 2,
    style: "percent"
  },
  [NumberFormat.RoundPercentageFormat]: {
    maximumFractionDigits: 0,
    style: "percent"
  }
};
function numberFormatConverter(numberFormat) {
  return numberFormatMap[numberFormat];
}
const DefaultTimeZoneId = "384";
const DEFAULT_TIMEZONE_ID = DefaultTimeZoneId;
const timeZones = [
  {
    id: "1",
    name: "Asia/Kabul",
    offset: "+04:30",
    country: "Afghanistan"
  },
  {
    id: "2",
    name: "Europe/Mariehamn",
    offset: "+02:00",
    country: "Aland Islands"
  },
  {
    id: "3",
    name: "Europe/Tirane",
    offset: "+01:00",
    country: "Albania"
  },
  {
    id: "4",
    name: "Africa/Algiers",
    offset: "+01:00",
    country: "Algeria"
  },
  {
    id: "5",
    name: "Pacific/Pago_Pago",
    offset: "-11:00",
    country: "American Samoa"
  },
  {
    id: "6",
    name: "Europe/Andorra",
    offset: "+01:00",
    country: "Andorra"
  },
  {
    id: "7",
    name: "Africa/Luanda",
    offset: "+01:00",
    country: "Angola"
  },
  {
    id: "8",
    name: "America/Anguilla",
    offset: "-04:00",
    country: "Anguilla"
  },
  {
    id: "14",
    name: "Antarctica/McMurdo",
    offset: "+12:00",
    country: "Antarctica"
  },
  {
    id: "15",
    name: "Antarctica/Palmer",
    offset: "-04:00",
    country: "Antarctica"
  },
  {
    id: "9",
    name: "Antarctica/Casey",
    offset: "+08:00",
    country: "Antarctica"
  },
  {
    id: "16",
    name: "Antarctica/Rothera",
    offset: "-03:00",
    country: "Antarctica"
  },
  {
    id: "10",
    name: "Antarctica/Davis",
    offset: "+07:00",
    country: "Antarctica"
  },
  {
    id: "18",
    name: "Antarctica/Syowa",
    offset: "+03:00",
    country: "Antarctica"
  },
  {
    id: "11",
    name: "Antarctica/DumontDUrville",
    offset: "+10:00",
    country: "Antarctica"
  },
  {
    id: "19",
    name: "Antarctica/Vostok",
    offset: "+06:00",
    country: "Antarctica"
  },
  {
    id: "12",
    name: "Antarctica/Macquarie",
    offset: "+11:00",
    country: "Antarctica"
  },
  {
    id: "13",
    name: "Antarctica/Mawson",
    offset: "+05:00",
    country: "Antarctica"
  },
  {
    id: "20",
    name: "America/Antigua",
    offset: "-04:00",
    country: "Antigua & Barbuda"
  },
  {
    id: "21",
    name: "America/Argentina/Buenos_Aires",
    offset: "-03:00",
    country: "Argentina"
  },
  {
    id: "28",
    name: "America/Argentina/Salta",
    offset: "-03:00",
    country: "Argentina"
  },
  {
    id: "22",
    name: "America/Argentina/Catamarca",
    offset: "-03:00",
    country: "Argentina"
  },
  {
    id: "29",
    name: "America/Argentina/San_Juan",
    offset: "-03:00",
    country: "Argentina"
  },
  {
    id: "23",
    name: "America/Argentina/Cordoba",
    offset: "-03:00",
    country: "Argentina"
  },
  {
    id: "30",
    name: "America/Argentina/San_Luis",
    offset: "-04:00",
    country: "Argentina"
  },
  {
    id: "433",
    name: "America/Mendoza",
    offset: "-03:00",
    country: "Argentina"
  },
  {
    id: "24",
    name: "America/Argentina/Jujuy",
    offset: "-03:00",
    country: "Argentina"
  },
  {
    id: "31",
    name: "America/Argentina/Tucuman",
    offset: "-03:00",
    country: "Argentina"
  },
  {
    id: "25",
    name: "America/Argentina/La_Rioja",
    offset: "-03:00",
    country: "Argentina"
  },
  {
    id: "32",
    name: "America/Argentina/Ushuaia",
    offset: "-03:00",
    country: "Argentina"
  },
  {
    id: "26",
    name: "America/Argentina/Mendoza",
    offset: "-03:00",
    country: "Argentina"
  },
  {
    id: "27",
    name: "America/Argentina/Rio_Gallegos",
    offset: "-03:00",
    country: "Argentina"
  },
  {
    id: "33",
    name: "Asia/Yerevan",
    offset: "+04:00",
    country: "Armenia"
  },
  {
    id: "34",
    name: "America/Aruba",
    offset: "-04:00",
    country: "Aruba"
  },
  {
    id: "449",
    name: "Australia/West",
    offset: "+08:00",
    country: "Australia"
  },
  {
    id: "40",
    name: "Australia/Eucla",
    offset: "+08:45",
    country: "Australia"
  },
  {
    id: "443",
    name: "Australia/North",
    offset: "+09:30",
    country: "Australia"
  },
  {
    id: "41",
    name: "Australia/Hobart",
    offset: "+11:00",
    country: "Australia"
  },
  {
    id: "444",
    name: "Australia/NSW",
    offset: "+11:00",
    country: "Australia"
  },
  {
    id: "35",
    name: "Australia/Adelaide",
    offset: "+10:30",
    country: "Australia"
  },
  {
    id: "42",
    name: "Australia/Lindeman",
    offset: "+10:00",
    country: "Australia"
  },
  {
    id: "445",
    name: "Australia/Queensland",
    offset: "+10:00",
    country: "Australia"
  },
  {
    id: "36",
    name: "Australia/Brisbane",
    offset: "+10:00",
    country: "Australia"
  },
  {
    id: "43",
    name: "Australia/Lord_Howe",
    offset: "+11:30",
    country: "Australia"
  },
  {
    id: "446",
    name: "Australia/South",
    offset: "+10:30",
    country: "Australia"
  },
  {
    id: "37",
    name: "Australia/Broken_Hill",
    offset: "+10:30",
    country: "Australia"
  },
  {
    id: "44",
    name: "Australia/Melbourne",
    offset: "+11:00",
    country: "Australia"
  },
  {
    id: "447",
    name: "Australia/Tasmania",
    offset: "+11:00",
    country: "Australia"
  },
  {
    id: "38",
    name: "Australia/Currie",
    offset: "+11:00",
    country: "Australia"
  },
  {
    id: "45",
    name: "Australia/Perth",
    offset: "+08:00",
    country: "Australia"
  },
  {
    id: "448",
    name: "Australia/Victoria",
    offset: "+11:00",
    country: "Australia"
  },
  {
    id: "39",
    name: "Australia/Darwin",
    offset: "+09:30",
    country: "Australia"
  },
  {
    id: "442",
    name: "Australia/Canberra",
    offset: "+11:00",
    country: "Australia"
  },
  {
    id: "46",
    name: "Australia/Sydney",
    offset: "+11:00",
    country: "Australia"
  },
  {
    id: "47",
    name: "Europe/Vienna",
    offset: "+01:00",
    country: "Austria"
  },
  {
    id: "48",
    name: "Asia/Baku",
    offset: "+04:00",
    country: "Azerbaijan"
  },
  {
    id: "49",
    name: "America/Nassau",
    offset: "-05:00",
    country: "Bahamas"
  },
  {
    id: "50",
    name: "Asia/Bahrain",
    offset: "+03:00",
    country: "Bahrain"
  },
  {
    id: "51",
    name: "Asia/Dhaka",
    offset: "+06:00",
    country: "Bangladesh"
  },
  {
    id: "52",
    name: "America/Barbados",
    offset: "-04:00",
    country: "Barbados"
  },
  {
    id: "53",
    name: "Europe/Minsk",
    offset: "+02:00",
    country: "Belarus"
  },
  {
    id: "54",
    name: "Europe/Brussels",
    offset: "+01:00",
    country: "Belgium"
  },
  {
    id: "55",
    name: "America/Belize",
    offset: "-06:00",
    country: "Belize"
  },
  {
    id: "56",
    name: "Africa/Porto-Novo",
    offset: "+01:00",
    country: "Benin"
  },
  {
    id: "57",
    name: "Atlantic/Bermuda",
    offset: "-04:00",
    country: "Bermuda"
  },
  {
    id: "58",
    name: "Asia/Thimphu",
    offset: "+06:00",
    country: "Bhutan"
  },
  {
    id: "59",
    name: "America/La_Paz",
    offset: "-04:00",
    country: "Bolivia"
  },
  {
    id: "60",
    name: "Europe/Sarajevo",
    offset: "+01:00",
    country: "Bosnia and Herzegovina"
  },
  {
    id: "61",
    name: "Africa/Gaborone",
    offset: "+02:00",
    country: "Botswana"
  },
  {
    id: "72",
    name: "America/Noronha",
    offset: "-02:00",
    country: "Brazil"
  },
  {
    id: "66",
    name: "America/Campo_Grande",
    offset: "-03:00",
    country: "Brazil"
  },
  {
    id: "73",
    name: "America/Porto_Velho",
    offset: "-04:00",
    country: "Brazil"
  },
  {
    id: "450",
    name: "Brazil/Acre",
    offset: "-05:00",
    country: "Brazil"
  },
  {
    id: "67",
    name: "America/Cuiaba",
    offset: "-03:00",
    country: "Brazil"
  },
  {
    id: "74",
    name: "America/Recife",
    offset: "-03:00",
    country: "Brazil"
  },
  {
    id: "68",
    name: "America/Eirunepe",
    offset: "-04:00",
    country: "Brazil"
  },
  {
    id: "62",
    name: "America/Araguaina",
    offset: "-03:00",
    country: "Brazil"
  },
  {
    id: "75",
    name: "America/Rio_Branco",
    offset: "-04:00",
    country: "Brazil"
  },
  {
    id: "69",
    name: "America/Fortaleza",
    offset: "-03:00",
    country: "Brazil"
  },
  {
    id: "63",
    name: "America/Bahia",
    offset: "-03:00",
    country: "Brazil"
  },
  {
    id: "76",
    name: "America/Santarem",
    offset: "-03:00",
    country: "Brazil"
  },
  {
    id: "70",
    name: "America/Maceio",
    offset: "-03:00",
    country: "Brazil"
  },
  {
    id: "64",
    name: "America/Belem",
    offset: "-03:00",
    country: "Brazil"
  },
  {
    id: "77",
    name: "America/Sao_Paulo",
    offset: "-02:00",
    country: "Brazil"
  },
  {
    id: "71",
    name: "America/Manaus",
    offset: "-04:00",
    country: "Brazil"
  },
  {
    id: "65",
    name: "America/Boa_Vista",
    offset: "-04:00",
    country: "Brazil"
  },
  {
    id: "78",
    name: "Indian/Chagos",
    offset: "+06:00",
    country: "British Indian Ocean Territory"
  },
  {
    id: "79",
    name: "Asia/Brunei",
    offset: "+08:00",
    country: "Brunei Darussalam"
  },
  {
    id: "80",
    name: "Europe/Sofia",
    offset: "+02:00",
    country: "Bulgaria"
  },
  {
    id: "81",
    name: "Africa/Ouagadougou",
    offset: "+00:00",
    country: "Burkina Faso"
  },
  {
    id: "82",
    name: "Africa/Bujumbura",
    offset: "+02:00",
    country: "Burundi"
  },
  {
    id: "112",
    name: "Atlantic/Cape_Verde",
    offset: "-01:00",
    country: "Cape Verde"
  },
  {
    id: "83",
    name: "Asia/Phnom_Penh",
    offset: "+07:00",
    country: "Cambodia"
  },
  {
    id: "84",
    name: "Africa/Douala",
    offset: "+01:00",
    country: "Cameroon"
  },
  {
    id: "105",
    name: "America/Swift_Current",
    offset: "-06:00",
    country: "Canada"
  },
  {
    id: "85",
    name: "America/Atikokan",
    offset: "-05:00",
    country: "Canada"
  },
  {
    id: "99",
    name: "America/Pangnirtung",
    offset: "-05:00",
    country: "Canada"
  },
  {
    id: "92",
    name: "America/Goose_Bay",
    offset: "-04:00",
    country: "Canada"
  },
  {
    id: "106",
    name: "America/Thunder_Bay",
    offset: "-05:00",
    country: "Canada"
  },
  {
    id: "86",
    name: "America/Blanc-Sablon",
    offset: "-04:00",
    country: "Canada"
  },
  {
    id: "100",
    name: "America/Rainy_River",
    offset: "-06:00",
    country: "Canada"
  },
  {
    id: "93",
    name: "America/Halifax",
    offset: "-04:00",
    country: "Canada"
  },
  {
    id: "107",
    name: "America/Toronto",
    offset: "-05:00",
    country: "Canada"
  },
  {
    id: "87",
    name: "America/Cambridge_Bay",
    offset: "-07:00",
    country: "Canada"
  },
  {
    id: "101",
    name: "America/Rankin_Inlet",
    offset: "-06:00",
    country: "Canada"
  },
  {
    id: "94",
    name: "America/Inuvik",
    offset: "-07:00",
    country: "Canada"
  },
  {
    id: "108",
    name: "America/Vancouver",
    offset: "-08:00",
    country: "Canada"
  },
  {
    id: "88",
    name: "America/Dawson",
    offset: "-08:00",
    country: "Canada"
  },
  {
    id: "102",
    name: "America/Regina",
    offset: "-06:00",
    country: "Canada"
  },
  {
    id: "95",
    name: "America/Iqaluit",
    offset: "-05:00",
    country: "Canada"
  },
  {
    id: "109",
    name: "America/Whitehorse",
    offset: "-08:00",
    country: "Canada"
  },
  {
    id: "434",
    name: "America/Montreal",
    offset: "-05:00",
    country: "Canada"
  },
  {
    id: "89",
    name: "America/Dawson_Creek",
    offset: "-07:00",
    country: "Canada"
  },
  {
    id: "103",
    name: "America/Resolute",
    offset: "-05:00",
    country: "Canada"
  },
  {
    id: "96",
    name: "America/Moncton",
    offset: "-04:00",
    country: "Canada"
  },
  {
    id: "110",
    name: "America/Winnipeg",
    offset: "-06:00",
    country: "Canada"
  },
  {
    id: "90",
    name: "America/Edmonton",
    offset: "-07:00",
    country: "Canada"
  },
  {
    id: "104",
    name: "America/St_Johns",
    offset: "-03:30",
    country: "Canada"
  },
  {
    id: "98",
    name: "America/Nipigon",
    offset: "-05:00",
    country: "Canada"
  },
  {
    id: "111",
    name: "America/Yellowknife",
    offset: "-07:00",
    country: "Canada"
  },
  {
    id: "91",
    name: "America/Glace_Bay",
    offset: "-04:00",
    country: "Canada"
  },
  {
    id: "113",
    name: "America/Cayman",
    offset: "-05:00",
    country: "Cayman Islands"
  },
  {
    id: "114",
    name: "Africa/Bangui",
    offset: "+01:00",
    country: "Central African Republic"
  },
  {
    id: "115",
    name: "Africa/Ndjamena",
    offset: "+01:00",
    country: "Chad"
  },
  {
    id: "451",
    name: "Chile/Continental",
    offset: "-03:00",
    country: "Chile"
  },
  {
    id: "116",
    name: "America/Santiago",
    offset: "-03:00",
    country: "Chile"
  },
  {
    id: "117",
    name: "Pacific/Easter",
    offset: "-05:00",
    country: "Chile"
  },
  {
    id: "121",
    name: "Asia/Shanghai",
    offset: "+08:00",
    country: "China"
  },
  {
    id: "437",
    name: "Asia/Harbin",
    offset: "+08:00",
    country: "China"
  },
  {
    id: "122",
    name: "Asia/Urumqi",
    offset: "+08:00",
    country: "China"
  },
  {
    id: "436",
    name: "Asia/Chongqing",
    offset: "+08:00",
    country: "China"
  },
  {
    id: "123",
    name: "Indian/Christmas",
    offset: "+07:00",
    country: "Christmas Island"
  },
  {
    id: "124",
    name: "Indian/Cocos",
    offset: "+06:30",
    country: "Cocos Islands (Keeling) "
  },
  {
    id: "125",
    name: "America/Bogota",
    offset: "-05:00",
    country: "Colombia"
  },
  {
    id: "126",
    name: "Indian/Comoro",
    offset: "+03:00",
    country: "Comoros"
  },
  {
    id: "127",
    name: "Africa/Brazzaville",
    offset: "+01:00",
    country: "Congo"
  },
  {
    id: "128",
    name: "Africa/Kinshasa",
    offset: "+01:00",
    country: "Democratic Republic of the Congo"
  },
  {
    id: "129",
    name: "Africa/Lubumbashi",
    offset: "+02:00",
    country: "Democratic Republic of the Congo"
  },
  {
    id: "130",
    name: "Pacific/Rarotonga",
    offset: "-10:00",
    country: "Cook Islands"
  },
  {
    id: "131",
    name: "America/Costa_Rica",
    offset: "-06:00",
    country: "Costa Rica"
  },
  {
    id: "132",
    name: "Africa/Abidjan",
    offset: "+00:00",
    country: "Cote d'Ivoire"
  },
  {
    id: "133",
    name: "Europe/Zagreb",
    offset: "+01:00",
    country: "Croatia"
  },
  {
    id: "134",
    name: "America/Havana",
    offset: "-05:00",
    country: "Cuba"
  },
  {
    id: "135",
    name: "Asia/Nicosia",
    offset: "+02:00",
    country: "Cyprus"
  },
  {
    id: "136",
    name: "Europe/Prague",
    offset: "+01:00",
    country: "Czech Republic"
  },
  {
    id: "137",
    name: "Europe/Copenhagen",
    offset: "+01:00",
    country: "Denmark"
  },
  {
    id: "138",
    name: "Africa/Djibouti",
    offset: "+03:00",
    country: "Djibouti"
  },
  {
    id: "139",
    name: "America/Dominica",
    offset: "-04:00",
    country: "Dominica"
  },
  {
    id: "140",
    name: "America/Santo_Domingo",
    offset: "-04:00",
    country: "Dominican Republic"
  },
  {
    id: "141",
    name: "America/Guayaquil",
    offset: "-05:00",
    country: "Ecuador"
  },
  {
    id: "142",
    name: "Pacific/Galapagos",
    offset: "-06:00",
    country: "Ecuador"
  },
  {
    id: "143",
    name: "Africa/Cairo",
    offset: "+02:00",
    country: "Egypt"
  },
  {
    id: "144",
    name: "America/El_Salvador",
    offset: "-06:00",
    country: "El Salvador"
  },
  {
    id: "145",
    name: "Africa/Malabo",
    offset: "+01:00",
    country: "Equatorial Guinea"
  },
  {
    id: "431",
    name: "Africa/Asmera",
    offset: "+03:00",
    country: "Eritrea"
  },
  {
    id: "146",
    name: "Africa/Asmara",
    offset: "+03:00",
    country: "Eritrea"
  },
  {
    id: "147",
    name: "Europe/Tallinn",
    offset: "+02:00",
    country: "Estonia"
  },
  {
    id: "148",
    name: "Africa/Addis_Ababa",
    offset: "+03:00",
    country: "Ethiopia"
  },
  {
    id: "149",
    name: "Atlantic/Stanley",
    offset: "-04:00",
    country: "Falkland Islands (Malvinas)"
  },
  {
    id: "150",
    name: "Atlantic/Faroe",
    offset: "+00:00",
    country: "Faroe Islands"
  },
  {
    id: "441",
    name: "Atlantic/Faeroe",
    offset: "+00:00",
    country: "Faroe Islands"
  },
  {
    id: "151",
    name: "Pacific/Fiji",
    offset: "+12:00",
    country: "Fiji"
  },
  {
    id: "152",
    name: "Europe/Helsinki",
    offset: "+02:00",
    country: "Finland"
  },
  {
    id: "153",
    name: "Europe/Paris",
    offset: "+01:00",
    country: "France"
  },
  {
    id: "154",
    name: "America/Cayenne",
    offset: "-03:00",
    country: "French Guiana"
  },
  {
    id: "155",
    name: "Pacific/Gambier",
    offset: "-09:00",
    country: "French Polynesia"
  },
  {
    id: "156",
    name: "Pacific/Marquesas",
    offset: "-09:30",
    country: "French Polynesia"
  },
  {
    id: "157",
    name: "Pacific/Tahiti",
    offset: "-10:00",
    country: "French Polynesia"
  },
  {
    id: "158",
    name: "Indian/Kerguelen",
    offset: "+05:00",
    country: "French Southern Territories"
  },
  {
    id: "159",
    name: "Africa/Libreville",
    offset: "+01:00",
    country: "Gabon"
  },
  {
    id: "160",
    name: "Africa/Banjul",
    offset: "+00:00",
    country: "Gambia"
  },
  {
    id: "161",
    name: "Asia/Tbilisi",
    offset: "+04:00",
    country: "Georgia"
  },
  {
    id: "162",
    name: "Europe/Berlin",
    offset: "+01:00",
    country: "Germany"
  },
  {
    id: "163",
    name: "Africa/Accra",
    offset: "+00:00",
    country: "Ghana"
  },
  {
    id: "164",
    name: "Europe/Gibraltar",
    offset: "+01:00",
    country: "Gibraltar"
  },
  {
    id: "165",
    name: "Europe/Athens",
    offset: "+02:00",
    country: "Greece"
  },
  {
    id: "166",
    name: "America/Danmarkshavn",
    offset: "+00:00",
    country: "Greenland"
  },
  {
    id: "167",
    name: "America/Godthab",
    offset: "-03:00",
    country: "Greenland"
  },
  {
    id: "168",
    name: "America/Scoresbysund",
    offset: "-01:00",
    country: "Greenland"
  },
  {
    id: "169",
    name: "America/Thule",
    offset: "-04:00",
    country: "Greenland"
  },
  {
    id: "170",
    name: "America/Grenada",
    offset: "-04:00",
    country: "Grenada"
  },
  {
    id: "171",
    name: "America/Guadeloupe",
    offset: "-04:00",
    country: "Guadeloupe"
  },
  {
    id: "172",
    name: "Pacific/Guam",
    offset: "+10:00",
    country: "Guam"
  },
  {
    id: "173",
    name: "America/Guatemala",
    offset: "-06:00",
    country: "Guatemala"
  },
  {
    id: "174",
    name: "Europe/Guernsey",
    offset: "+00:00",
    country: "Guernsey"
  },
  {
    id: "175",
    name: "Africa/Conakry",
    offset: "+00:00",
    country: "Guinea"
  },
  {
    id: "176",
    name: "Africa/Bissau",
    offset: "+00:00",
    country: "Guinea-bissau"
  },
  {
    id: "177",
    name: "America/Guyana",
    offset: "-04:00",
    country: "Guyana"
  },
  {
    id: "178",
    name: "America/Port-au-Prince",
    offset: "-05:00",
    country: "Haiti"
  },
  {
    id: "179",
    name: "America/Tegucigalpa",
    offset: "-06:00",
    country: "Honduras"
  },
  {
    id: "180",
    name: "Asia/Hong_Kong",
    offset: "+08:00",
    country: "Hong Kong"
  },
  {
    id: "181",
    name: "Europe/Budapest",
    offset: "+01:00",
    country: "Hungary"
  },
  {
    id: "182",
    name: "Atlantic/Reykjavik",
    offset: "+00:00",
    country: "Iceland"
  },
  {
    id: "183",
    name: "Asia/Kolkata",
    offset: "+05:30",
    country: "India"
  },
  {
    id: "435",
    name: "Asia/Calcutta",
    offset: "+05:30",
    country: "India"
  },
  {
    id: "185",
    name: "Asia/Jayapura",
    offset: "+09:00",
    country: "Indonesia"
  },
  {
    id: "186",
    name: "Asia/Makassar",
    offset: "+08:00",
    country: "Indonesia"
  },
  {
    id: "187",
    name: "Asia/Pontianak",
    offset: "+07:00",
    country: "Indonesia"
  },
  {
    id: "184",
    name: "Asia/Jakarta",
    offset: "+07:00",
    country: "Indonesia"
  },
  {
    id: "188",
    name: "Asia/Tehran",
    offset: "+03:30",
    country: "Islamic republic of Iran"
  },
  {
    id: "189",
    name: "Asia/Baghdad",
    offset: "+03:00",
    country: "Iraq"
  },
  {
    id: "190",
    name: "Europe/Dublin",
    offset: "+00:00",
    country: "Ireland"
  },
  {
    id: "191",
    name: "Europe/Isle_of_Man",
    offset: "+00:00",
    country: "Isle of man"
  },
  {
    id: "192",
    name: "Asia/Jerusalem",
    offset: "+02:00",
    country: "Israel"
  },
  {
    id: "193",
    name: "Europe/Rome",
    offset: "+01:00",
    country: "Italy"
  },
  {
    id: "194",
    name: "America/Jamaica",
    offset: "-05:00",
    country: "Jamaica"
  },
  {
    id: "195",
    name: "Asia/Tokyo",
    offset: "+09:00",
    country: "Japan"
  },
  {
    id: "196",
    name: "Europe/Jersey",
    offset: "+00:00",
    country: "Jersey"
  },
  {
    id: "197",
    name: "Asia/Amman",
    offset: "+02:00",
    country: "Jordan"
  },
  {
    id: "198",
    name: "Asia/Almaty",
    offset: "+06:00",
    country: "Kazakhstan"
  },
  {
    id: "199",
    name: "Asia/Aqtau",
    offset: "+05:00",
    country: "Kazakhstan"
  },
  {
    id: "200",
    name: "Asia/Aqtobe",
    offset: "+05:00",
    country: "Kazakhstan"
  },
  {
    id: "201",
    name: "Asia/Oral",
    offset: "+05:00",
    country: "Kazakhstan"
  },
  {
    id: "202",
    name: "Asia/Qyzylorda",
    offset: "+06:00",
    country: "Kazakhstan"
  },
  {
    id: "203",
    name: "Africa/Nairobi",
    offset: "+03:00",
    country: "Kenya"
  },
  {
    id: "204",
    name: "Pacific/Enderbury",
    offset: "+13:00",
    country: "Kiribati"
  },
  {
    id: "206",
    name: "Pacific/Tarawa",
    offset: "+12:00",
    country: "Kiribati"
  },
  {
    id: "207",
    name: "Asia/Pyongyang",
    offset: "+09:00",
    country: "Democratic people's republic of Korea"
  },
  {
    id: "208",
    name: "Asia/Seoul",
    offset: "+09:00",
    country: "Republic of Korea"
  },
  {
    id: "209",
    name: "Asia/Kuwait",
    offset: "+03:00",
    country: "Kuwait"
  },
  {
    id: "210",
    name: "Asia/Bishkek",
    offset: "+06:00",
    country: "Kyrgyzstan"
  },
  {
    id: "211",
    name: "Asia/Vientiane",
    offset: "+07:00",
    country: "People's democratic republic of Lao"
  },
  {
    id: "212",
    name: "Europe/Riga",
    offset: "+02:00",
    country: "Latvia"
  },
  {
    id: "213",
    name: "Asia/Beirut",
    offset: "+02:00",
    country: "Lebanon"
  },
  {
    id: "214",
    name: "Africa/Maseru",
    offset: "+02:00",
    country: "Lesotho"
  },
  {
    id: "215",
    name: "Africa/Monrovia",
    offset: "+00:00",
    country: "Liberia"
  },
  {
    id: "216",
    name: "Africa/Tripoli",
    offset: "+02:00",
    country: "Libya"
  },
  {
    id: "217",
    name: "Europe/Vaduz",
    offset: "+01:00",
    country: "Liechtenstein"
  },
  {
    id: "218",
    name: "Europe/Vilnius",
    offset: "+02:00",
    country: "Lithuania"
  },
  {
    id: "219",
    name: "Europe/Luxembourg",
    offset: "+01:00",
    country: "Luxembourg"
  },
  {
    id: "220",
    name: "Asia/Macau",
    offset: "+08:00",
    country: "Macao"
  },
  {
    id: "440",
    name: "Asia/Macao",
    offset: "+08:00",
    country: "Macao"
  },
  {
    id: "221",
    name: "Europe/Skopje",
    offset: "+01:00",
    country: "Republic of Macedonia"
  },
  {
    id: "222",
    name: "Indian/Antananarivo",
    offset: "+03:00",
    country: "Madagascar"
  },
  {
    id: "223",
    name: "Africa/Blantyre",
    offset: "+02:00",
    country: "Malawi"
  },
  {
    id: "225",
    name: "Asia/Kuching",
    offset: "+08:00",
    country: "Malaysia"
  },
  {
    id: "224",
    name: "Asia/Kuala_Lumpur",
    offset: "+08:00",
    country: "Malaysia"
  },
  {
    id: "226",
    name: "Indian/Maldives",
    offset: "+05:00",
    country: "Maldives"
  },
  {
    id: "227",
    name: "Africa/Bamako",
    offset: "+00:00",
    country: "Mali"
  },
  {
    id: "228",
    name: "Europe/Malta",
    offset: "+01:00",
    country: "Malta"
  },
  {
    id: "229",
    name: "Pacific/Kwajalein",
    offset: "+12:00",
    country: "Marshall Islands"
  },
  {
    id: "230",
    name: "Pacific/Majuro",
    offset: "+12:00",
    country: "Marshall Islands"
  },
  {
    id: "231",
    name: "America/Martinique",
    offset: "-04:00",
    country: "Martinique"
  },
  {
    id: "232",
    name: "Africa/Nouakchott",
    offset: "+00:00",
    country: "Mauritania"
  },
  {
    id: "233",
    name: "Indian/Mauritius",
    offset: "+04:00",
    country: "Mauritius"
  },
  {
    id: "234",
    name: "Indian/Mayotte",
    offset: "+03:00",
    country: "Mayotte"
  },
  {
    id: "237",
    name: "America/Chihuahua",
    offset: "-07:00",
    country: "Mexico"
  },
  {
    id: "244",
    name: "America/Ojinaga",
    offset: "-07:00",
    country: "Mexico"
  },
  {
    id: "238",
    name: "America/Hermosillo",
    offset: "-07:00",
    country: "Mexico"
  },
  {
    id: "245",
    name: "America/Santa_Isabel",
    offset: "-08:00",
    country: "Mexico"
  },
  {
    id: "239",
    name: "America/Matamoros",
    offset: "-06:00",
    country: "Mexico"
  },
  {
    id: "246",
    name: "America/Tijuana",
    offset: "-08:00",
    country: "Mexico"
  },
  {
    id: "240",
    name: "America/Mazatlan",
    offset: "-07:00",
    country: "Mexico"
  },
  {
    id: "241",
    name: "America/Merida",
    offset: "-06:00",
    country: "Mexico"
  },
  {
    id: "235",
    name: "America/Bahia_Banderas",
    offset: "-06:00",
    country: "Mexico"
  },
  {
    id: "242",
    name: "America/Mexico_City",
    offset: "-06:00",
    country: "Mexico"
  },
  {
    id: "236",
    name: "America/Cancun",
    offset: "-06:00",
    country: "Mexico"
  },
  {
    id: "243",
    name: "America/Monterrey",
    offset: "-06:00",
    country: "Mexico"
  },
  {
    id: "247",
    name: "Pacific/Chuuk",
    offset: "+10:00",
    country: "Federated states of Micronesia"
  },
  {
    id: "248",
    name: "Pacific/Kosrae",
    offset: "+11:00",
    country: "Federated states of Micronesia"
  },
  {
    id: "249",
    name: "Pacific/Pohnpei",
    offset: "+11:00",
    country: "Federated states of Micronesia"
  },
  {
    id: "250",
    name: "Europe/Chisinau",
    offset: "+02:00",
    country: "Republic of Moldova"
  },
  {
    id: "251",
    name: "Europe/Monaco",
    offset: "+01:00",
    country: "Monaco"
  },
  {
    id: "252",
    name: "Asia/Choibalsan",
    offset: "+08:00",
    country: "Mongolia"
  },
  {
    id: "253",
    name: "Asia/Hovd",
    offset: "+07:00",
    country: "Mongolia"
  },
  {
    id: "254",
    name: "Asia/Ulaanbaatar",
    offset: "+08:00",
    country: "Mongolia"
  },
  {
    id: "255",
    name: "Europe/Podgorica",
    offset: "+01:00",
    country: "Montenegro"
  },
  {
    id: "256",
    name: "America/Montserrat",
    offset: "-04:00",
    country: "Montserrat"
  },
  {
    id: "257",
    name: "Africa/Casablanca",
    offset: "+00:00",
    country: "Morocco"
  },
  {
    id: "258",
    name: "Africa/Maputo",
    offset: "+02:00",
    country: "Mozambique"
  },
  {
    id: "259",
    name: "Asia/Rangoon",
    offset: "+06:30",
    country: "Myanmar"
  },
  {
    id: "260",
    name: "Africa/Windhoek",
    offset: "+02:00",
    country: "Namibia"
  },
  {
    id: "261",
    name: "Pacific/Nauru",
    offset: "+12:00",
    country: "Nauru"
  },
  {
    id: "439",
    name: "Asia/Katmandu",
    offset: "+05:45",
    country: "Nepal"
  },
  {
    id: "262",
    name: "Asia/Kathmandu",
    offset: "+05:45",
    country: "Nepal"
  },
  {
    id: "263",
    name: "Europe/Amsterdam",
    offset: "+01:00",
    country: "Netherlands"
  },
  {
    id: "264",
    name: "America/Curacao",
    offset: "-04:00",
    country: "Netherlands Antilles"
  },
  {
    id: "265",
    name: "Pacific/Noumea",
    offset: "+11:00",
    country: "New Caledonia"
  },
  {
    id: "266",
    name: "Pacific/Auckland",
    offset: "+12:00",
    country: "New Zealand"
  },
  {
    id: "267",
    name: "Pacific/Chatham",
    offset: "+12:45",
    country: "New Zealand"
  },
  {
    id: "268",
    name: "America/Managua",
    offset: "-06:00",
    country: "Nicaragua"
  },
  {
    id: "269",
    name: "Africa/Niamey",
    offset: "+01:00",
    country: "Niger"
  },
  {
    id: "270",
    name: "Africa/Lagos",
    offset: "+01:00",
    country: "Nigeria"
  },
  {
    id: "271",
    name: "Pacific/Niue",
    offset: "-11:00",
    country: "Niue"
  },
  {
    id: "272",
    name: "Pacific/Norfolk",
    offset: "+11:30",
    country: "Norfolk Island"
  },
  {
    id: "273",
    name: "Pacific/Saipan",
    offset: "+10:00",
    country: "Northern Mariana Islands"
  },
  {
    id: "274",
    name: "Europe/Oslo",
    offset: "+01:00",
    country: "Norway"
  },
  {
    id: "275",
    name: "Asia/Muscat",
    offset: "+04:00",
    country: "Oman"
  },
  {
    id: "276",
    name: "Asia/Karachi",
    offset: "+05:00",
    country: "Pakistan"
  },
  {
    id: "277",
    name: "Pacific/Palau",
    offset: "+09:00",
    country: "Palau"
  },
  {
    id: "278",
    name: "Asia/Gaza",
    offset: "+02:00",
    country: "Occupied Palestinian Territory"
  },
  {
    id: "279",
    name: "America/Panama",
    offset: "-05:00",
    country: "Panama"
  },
  {
    id: "280",
    name: "Pacific/Port_Moresby",
    offset: "+10:00",
    country: "Papua New Guinea"
  },
  {
    id: "281",
    name: "America/Asuncion",
    offset: "-03:00",
    country: "Paraguay"
  },
  {
    id: "282",
    name: "America/Lima",
    offset: "-05:00",
    country: "Peru"
  },
  {
    id: "283",
    name: "Asia/Manila",
    offset: "+08:00",
    country: "Philippines"
  },
  {
    id: "284",
    name: "Pacific/Pitcairn",
    offset: "-08:00",
    country: "Pitcairn"
  },
  {
    id: "285",
    name: "Europe/Warsaw",
    offset: "+01:00",
    country: "Poland"
  },
  {
    id: "286",
    name: "Atlantic/Azores",
    offset: "-01:00",
    country: "Portugal"
  },
  {
    id: "287",
    name: "Atlantic/Madeira",
    offset: "+00:00",
    country: "Portugal"
  },
  {
    id: "288",
    name: "Europe/Lisbon",
    offset: "+00:00",
    country: "Portugal"
  },
  {
    id: "289",
    name: "America/Puerto_Rico",
    offset: "-04:00",
    country: "Puerto Rico"
  },
  {
    id: "290",
    name: "Asia/Qatar",
    offset: "+03:00",
    country: "Qatar"
  },
  {
    id: "291",
    name: "Indian/Reunion",
    offset: "+04:00",
    country: "R\xE9union"
  },
  {
    id: "292",
    name: "Europe/Bucharest",
    offset: "+02:00",
    country: "Romania"
  },
  {
    id: "301",
    name: "Asia/Sakhalin",
    offset: "+10:00",
    country: "Russian Federation"
  },
  {
    id: "430",
    name: "Asia/Chita",
    offset: "+09:00",
    country: "Russian Federation"
  },
  {
    id: "295",
    name: "Asia/Kamchatka",
    offset: "+11:00",
    country: "Russian Federation"
  },
  {
    id: "308",
    name: "Europe/Volgograd",
    offset: "+03:00",
    country: "Russian Federation"
  },
  {
    id: "302",
    name: "Asia/Vladivostok",
    offset: "+10:00",
    country: "Russian Federation"
  },
  {
    id: "296",
    name: "Asia/Krasnoyarsk",
    offset: "+07:00",
    country: "Russian Federation"
  },
  {
    id: "303",
    name: "Asia/Yakutsk",
    offset: "+09:00",
    country: "Russian Federation"
  },
  {
    id: "297",
    name: "Asia/Magadan",
    offset: "+11:00",
    country: "Russian Federation"
  },
  {
    id: "304",
    name: "Asia/Yekaterinburg",
    offset: "+05:00",
    country: "Russian Federation"
  },
  {
    id: "298",
    name: "Asia/Novokuznetsk",
    offset: "+06:00",
    country: "Russian Federation"
  },
  {
    id: "305",
    name: "Europe/Kaliningrad",
    offset: "+02:00",
    country: "Russian Federation"
  },
  {
    id: "299",
    name: "Asia/Novosibirsk",
    offset: "+07:00",
    country: "Russian Federation"
  },
  {
    id: "293",
    name: "Asia/Anadyr",
    offset: "+11:00",
    country: "Russian Federation"
  },
  {
    id: "306",
    name: "Europe/Moscow",
    offset: "+03:00",
    country: "Russian Federation"
  },
  {
    id: "300",
    name: "Asia/Omsk",
    offset: "+06:00",
    country: "Russian Federation"
  },
  {
    id: "294",
    name: "Asia/Irkutsk",
    offset: "+08:00",
    country: "Russian Federation"
  },
  {
    id: "307",
    name: "Europe/Samara",
    offset: "+04:00",
    country: "Russian Federation"
  },
  {
    id: "309",
    name: "Africa/Kigali",
    offset: "+02:00",
    country: "Rwanda"
  },
  {
    id: "310",
    name: "America/St_Barthelemy",
    offset: "-04:00",
    country: "Saint Barth\xE9lemy"
  },
  {
    id: "311",
    name: "Atlantic/St_Helena",
    offset: "+00:00",
    country: "Saint Helena"
  },
  {
    id: "312",
    name: "America/St_Kitts",
    offset: "-04:00",
    country: "Saint Kitts and Nevis"
  },
  {
    id: "313",
    name: "America/St_Lucia",
    offset: "-04:00",
    country: "Saint Lucia"
  },
  {
    id: "314",
    name: "America/Marigot",
    offset: "-04:00",
    country: "Saint Martin"
  },
  {
    id: "315",
    name: "America/Miquelon",
    offset: "-03:00",
    country: "Saint Pierre and Miquelon"
  },
  {
    id: "316",
    name: "America/St_Vincent",
    offset: "-04:00",
    country: "Saint Vincent and the Grenadines"
  },
  {
    id: "452",
    name: "Pacific/Samoa",
    offset: "+13:00",
    country: "Samoa"
  },
  {
    id: "317",
    name: "Pacific/Apia",
    offset: "-11:00",
    country: "Samoa"
  },
  {
    id: "318",
    name: "Europe/San_Marino",
    offset: "+01:00",
    country: "San Marino"
  },
  {
    id: "319",
    name: "Africa/Sao_Tome",
    offset: "+00:00",
    country: "Sao Tome and Principe"
  },
  {
    id: "320",
    name: "Asia/Riyadh",
    offset: "+03:00",
    country: "Saudi Arabia"
  },
  {
    id: "321",
    name: "Africa/Dakar",
    offset: "+00:00",
    country: "Senegal"
  },
  {
    id: "322",
    name: "Europe/Belgrade",
    offset: "+01:00",
    country: "Serbia"
  },
  {
    id: "323",
    name: "Indian/Mahe",
    offset: "+04:00",
    country: "Seychelles"
  },
  {
    id: "324",
    name: "Africa/Freetown",
    offset: "+00:00",
    country: "Sierra Leone"
  },
  {
    id: "325",
    name: "Asia/Singapore",
    offset: "+08:00",
    country: "Singapore"
  },
  {
    id: "326",
    name: "Europe/Bratislava",
    offset: "+01:00",
    country: "Slovakia"
  },
  {
    id: "327",
    name: "Europe/Ljubljana",
    offset: "+01:00",
    country: "Slovenia"
  },
  {
    id: "328",
    name: "Pacific/Guadalcanal",
    offset: "+11:00",
    country: "Solomon Islands"
  },
  {
    id: "329",
    name: "Africa/Mogadishu",
    offset: "+03:00",
    country: "Somalia"
  },
  {
    id: "330",
    name: "Africa/Johannesburg",
    offset: "+02:00",
    country: "South Africa"
  },
  {
    id: "331",
    name: "Atlantic/South_Georgia",
    offset: "-02:00",
    country: "South Georgia and the South Sandwich Islands"
  },
  {
    id: "333",
    name: "Atlantic/Canary",
    offset: "+00:00",
    country: "Spain"
  },
  {
    id: "334",
    name: "Europe/Madrid",
    offset: "+01:00",
    country: "Spain"
  },
  {
    id: "332",
    name: "Africa/Ceuta",
    offset: "+01:00",
    country: "Spain"
  },
  {
    id: "335",
    name: "Asia/Colombo",
    offset: "+05:30",
    country: "Sri Lanka"
  },
  {
    id: "336",
    name: "Africa/Khartoum",
    offset: "+03:00",
    country: "Sudan"
  },
  {
    id: "337",
    name: "America/Paramaribo",
    offset: "-03:00",
    country: "Suriname"
  },
  {
    id: "338",
    name: "Arctic/Longyearbyen",
    offset: "+01:00",
    country: "Svalbard and Jan Mayen"
  },
  {
    id: "339",
    name: "Africa/Mbabane",
    offset: "+02:00",
    country: "Swaziland"
  },
  {
    id: "340",
    name: "Europe/Stockholm",
    offset: "+01:00",
    country: "Sweden"
  },
  {
    id: "341",
    name: "Europe/Zurich",
    offset: "+01:00",
    country: "Switzerland"
  },
  {
    id: "342",
    name: "Asia/Damascus",
    offset: "+02:00",
    country: "Syrian Arab Republic"
  },
  {
    id: "343",
    name: "Asia/Taipei",
    offset: "+08:00",
    country: "Taiwan"
  },
  {
    id: "344",
    name: "Asia/Dushanbe",
    offset: "+05:00",
    country: "Tajikistan"
  },
  {
    id: "345",
    name: "Africa/Dar_es_Salaam",
    offset: "+03:00",
    country: "United Republic Of Tanzania"
  },
  {
    id: "346",
    name: "Asia/Bangkok",
    offset: "+07:00",
    country: "Thailand"
  },
  {
    id: "347",
    name: "Asia/Dili",
    offset: "+09:00",
    country: "Timor-Leste"
  },
  {
    id: "348",
    name: "Africa/Lome",
    offset: "+00:00",
    country: "Togo"
  },
  {
    id: "349",
    name: "Pacific/Fakaofo",
    offset: "-10:00",
    country: "Tokelau"
  },
  {
    id: "350",
    name: "Pacific/Tongatapu",
    offset: "+13:00",
    country: "Tonga"
  },
  {
    id: "351",
    name: "America/Port_of_Spain",
    offset: "-04:00",
    country: "Trinidad and Tobago"
  },
  {
    id: "352",
    name: "Africa/Tunis",
    offset: "+01:00",
    country: "Tunisia"
  },
  {
    id: "353",
    name: "Europe/Istanbul",
    offset: "+03:00",
    country: "Turkey"
  },
  {
    id: "438",
    name: "Asia/Istanbul",
    offset: "+03:00",
    country: "Turkey"
  },
  {
    id: "354",
    name: "Asia/Ashgabat",
    offset: "+05:00",
    country: "Turkmenistan"
  },
  {
    id: "355",
    name: "America/Grand_Turk",
    offset: "-05:00",
    country: "Turks and Caicos Islands"
  },
  {
    id: "356",
    name: "Pacific/Funafuti",
    offset: "+12:00",
    country: "Tuvalu"
  },
  {
    id: "357",
    name: "Africa/Kampala",
    offset: "+03:00",
    country: "Uganda"
  },
  {
    id: "359",
    name: "Europe/Simferopol",
    offset: "+02:00",
    country: "Ukraine"
  },
  {
    id: "360",
    name: "Europe/Uzhgorod",
    offset: "+02:00",
    country: "Ukraine"
  },
  {
    id: "361",
    name: "Europe/Zaporozhye",
    offset: "+02:00",
    country: "Ukraine"
  },
  {
    id: "358",
    name: "Europe/Kiev",
    offset: "+02:00",
    country: "Ukraine"
  },
  {
    id: "362",
    name: "Asia/Dubai",
    offset: "+04:00",
    country: "United Arab Emirates"
  },
  {
    id: "363",
    name: "Europe/London",
    offset: "+00:00",
    country: "United Kingdom"
  },
  {
    id: "365",
    name: "America/Anchorage",
    offset: "-09:00",
    country: "United States"
  },
  {
    id: "378",
    name: "America/Juneau",
    offset: "-09:00",
    country: "United States"
  },
  {
    id: "392",
    name: "America/Yakutat",
    offset: "-09:00",
    country: "United States"
  },
  {
    id: "372",
    name: "America/Indiana/Marengo",
    offset: "-05:00",
    country: "United States"
  },
  {
    id: "385",
    name: "America/Nome",
    offset: "-09:00",
    country: "United States"
  },
  {
    id: "366",
    name: "America/Boise",
    offset: "-07:00",
    country: "United States"
  },
  {
    id: "379",
    name: "America/Kentucky/Louisville",
    offset: "-05:00",
    country: "United States"
  },
  {
    id: "393",
    name: "Pacific/Honolulu",
    offset: "-10:00",
    country: "United States"
  },
  {
    id: "373",
    name: "America/Indiana/Petersburg",
    offset: "-05:00",
    country: "United States"
  },
  {
    id: "386",
    name: "America/North_Dakota/Beulah",
    offset: "-06:00",
    country: "United States"
  },
  {
    id: "367",
    name: "America/Chicago",
    offset: "-06:00",
    country: "United States"
  },
  {
    id: "432",
    name: "America/Indianapolis",
    offset: "-05:00",
    country: "United States"
  },
  {
    id: "380",
    name: "America/Kentucky/Monticello",
    offset: "-05:00",
    country: "United States"
  },
  {
    id: "374",
    name: "America/Indiana/Tell_City",
    offset: "-06:00",
    country: "United States"
  },
  {
    id: "387",
    name: "America/North_Dakota/Center",
    offset: "-06:00",
    country: "United States"
  },
  {
    id: "368",
    name: "America/Denver",
    offset: "-07:00",
    country: "United States"
  },
  {
    id: "381",
    name: "America/Los_Angeles",
    offset: "-08:00",
    country: "United States"
  },
  {
    id: "375",
    name: "America/Indiana/Vevay",
    offset: "-05:00",
    country: "United States"
  },
  {
    id: "388",
    name: "America/North_Dakota/New_Salem",
    offset: "-06:00",
    country: "United States"
  },
  {
    id: "453",
    name: "US/Samoa",
    offset: "-11:00",
    country: "United States"
  },
  {
    id: "369",
    name: "America/Detroit",
    offset: "-05:00",
    country: "United States"
  },
  {
    id: "382",
    name: "America/Menominee",
    offset: "-06:00",
    country: "United States"
  },
  {
    id: "376",
    name: "America/Indiana/Vincennes",
    offset: "-05:00",
    country: "United States"
  },
  {
    id: "389",
    name: "America/Phoenix",
    offset: "-07:00",
    country: "United States"
  },
  {
    id: "370",
    name: "America/Indiana/Indianapolis",
    offset: "-05:00",
    country: "United States"
  },
  {
    id: "383",
    name: "America/Metlakatla",
    offset: "-08:00",
    country: "United States"
  },
  {
    id: "364",
    name: "America/Adak",
    offset: "-10:00",
    country: "United States"
  },
  {
    id: "377",
    name: "America/Indiana/Winamac",
    offset: "-05:00",
    country: "United States"
  },
  {
    id: "391",
    name: "America/Sitka",
    offset: "-09:00",
    country: "United States"
  },
  {
    id: "371",
    name: "America/Indiana/Knox",
    offset: "-06:00",
    country: "United States"
  },
  {
    id: "384",
    name: "America/New_York",
    offset: "-05:00",
    country: "United States"
  },
  {
    id: "394",
    name: "Pacific/Johnston",
    offset: "-10:00",
    country: "United States Minor Outlying Islands"
  },
  {
    id: "395",
    name: "Pacific/Midway",
    offset: "-11:00",
    country: "United States Minor Outlying Islands"
  },
  {
    id: "396",
    name: "Pacific/Wake",
    offset: "+12:00",
    country: "United States Minor Outlying Islands"
  },
  {
    id: "397",
    name: "America/Montevideo",
    offset: "-03:00",
    country: "Uruguay"
  },
  {
    id: "398",
    name: "Asia/Samarkand",
    offset: "+05:00",
    country: "Uzbekistan"
  },
  {
    id: "399",
    name: "Asia/Tashkent",
    offset: "+05:00",
    country: "Uzbekistan"
  },
  {
    id: "400",
    name: "Pacific/Efate",
    offset: "+11:00",
    country: "Vanuatu"
  },
  {
    id: "401",
    name: "Europe/Vatican",
    offset: "+01:00",
    country: "Vatican City State"
  },
  {
    id: "402",
    name: "America/Caracas",
    offset: "-04:30",
    country: "Bolivarian Republic Of Venezuela"
  },
  {
    id: "403",
    name: "Asia/Ho_Chi_Minh",
    offset: "+07:00",
    country: "Vietnam"
  },
  {
    id: "404",
    name: "America/Tortola",
    offset: "-04:00",
    country: "British Virgin Islands"
  },
  {
    id: "405",
    name: "America/St_Thomas",
    offset: "-04:00",
    country: "U.S. Virgin Islands"
  },
  {
    id: "406",
    name: "Pacific/Wallis",
    offset: "+12:00",
    country: "Wallis and Futuna"
  },
  {
    id: "407",
    name: "Africa/El_Aaiun",
    offset: "+00:00",
    country: "Western Sahara"
  },
  {
    id: "408",
    name: "Asia/Aden",
    offset: "+03:00",
    country: "Yemen"
  },
  {
    id: "409",
    name: "Africa/Lusaka",
    offset: "+02:00",
    country: "Zambia"
  },
  {
    id: "410",
    name: "Africa/Harare",
    offset: "+02:00",
    country: "Zimbabwe"
  }
];
function filterTimeZone(timeZoneId) {
  return timeZones.find((timeZoneItem) => timeZoneItem.id === timeZoneId);
}
function guessTimeZone() {
  const guess = new Intl.DateTimeFormat().resolvedOptions().timeZone;
  const isSupported = timeZones.some((timeZone) => timeZone.name === guess);
  if (isSupported) {
    return guess;
  }
  return filterTimeZone(DEFAULT_TIMEZONE_ID).name;
}
function getTimeZoneNameById(timeZoneId) {
  if (timeZoneId) {
    const timeZone = filterTimeZone(timeZoneId);
    if (timeZone) {
      return timeZone.name;
    }
  }
  return guessTimeZone();
}
function getTranslationTools() {
  return globalThis.TranslationTools;
}
function mergeObjectWithDefaults(object, defaultValues) {
  if (object) {
    return Object.keys(object).reduce((result, key) => {
      var _a;
      return __spreadProps(__spreadValues({}, result), {
        [key]: (_a = object[key]) != null ? _a : defaultValues[key]
      });
    }, defaultValues);
  }
  return defaultValues;
}
class TranslationIntl {
  constructor(config, intlCache) {
    __publicField(this, "defaultTimeZone");
    __publicField(this, "locale");
    __publicField(this, "bcpLocale");
    __publicField(this, "intlService");
    __publicField(this, "logger");
    __publicField(this, "keyResolver");
    __publicField(this, "showKeyInfo");
    var _a;
    this.locale = config.locale;
    this.bcpLocale = convertGrLocaleToBcpLocale(config.locale);
    this.logger = new IntlLogger(isDevelopment);
    this.intlService = new IntlService({
      locale: config.locale,
      messages: config.messages,
      messageCache: intlCache,
      logger: this.logger
    });
    this.defaultTimeZone = getTimeZoneNameById(config.defaultTimeZoneId);
    this.keyResolver = (_a = config.keyResolver) != null ? _a : null;
    this.showKeyInfo = config.showKeyInfo;
  }
  translate(id, values) {
    var _a;
    const resolvedKey = this.resolveKey(id, values);
    const translation = this.getTranslation(resolvedKey, values);
    const overlay = (_a = getTranslationTools()) == null ? void 0 : _a.Overlay;
    if (overlay == null ? void 0 : overlay.isOn()) {
      return overlay.stampTranslation(this.getTranslationMetaData(resolvedKey, values), translation);
    }
    return translation;
  }
  translateString(id, values) {
    var _a;
    const resolvedKey = this.resolveKey(id, values);
    const value = this.getTranslation(resolvedKey, values);
    const overlay = (_a = getTranslationTools()) == null ? void 0 : _a.Overlay;
    if (overlay == null ? void 0 : overlay.isOn()) {
      return overlay.stampTranslation(this.getTranslationMetaData(resolvedKey, values), value).join("");
    }
    return value;
  }
  formatCurrency(value, currency, options) {
    var _a;
    const numberFormatOptions = mergeObjectWithDefaults(options, {
      currencyDisplay: CurrencyDisplay.SYMBOL,
      minimumFractionDigits: 2
    });
    const ten = 10;
    const multiplier = Math.pow(ten, (_a = numberFormatOptions.minimumFractionDigits) != null ? _a : 0);
    const currencyValue = Math.round(parseFloat(value.toString()) * multiplier) / multiplier;
    return new Intl.NumberFormat(this.bcpLocale, __spreadValues({
      style: "currency",
      currency
    }, numberFormatOptions)).format(currencyValue);
  }
  formatNumber(value, formatOrOptions = {}) {
    const options = typeof formatOrOptions === "string" ? numberFormatConverter(formatOrOptions) : formatOrOptions;
    return new Intl.NumberFormat(this.bcpLocale, options).format(value);
  }
  formatDate(value, options = {}) {
    const {
      format: dateFormatOrDateOptions = DateFormat.FULL_DATE_WITH_TIME_SHORT,
      timeZone = this.defaultTimeZone
    } = options;
    let date;
    if (typeof value === "string") {
      if (value === parseInt(value).toString()) {
        throw new Error("Invalid date format: timestamp string");
      }
      date = new Date(value);
      if (isNaN(date.getTime())) {
        throw new Error(`Invalid date value ${value}`);
      }
    } else {
      date = new Date(value);
    }
    const dateTimeFormatOptions = typeof dateFormatOrDateOptions === "string" ? dateFormatConverter(dateFormatOrDateOptions, timeZone) : __spreadValues({ timeZone }, dateFormatOrDateOptions);
    return new Intl.DateTimeFormat(this.bcpLocale, dateTimeFormatOptions).format(date).replace("AM", "am").replace("PM", "pm");
  }
  getIntlService() {
    return this.intlService;
  }
  getTimeZone() {
    return this.defaultTimeZone;
  }
  getTranslation(id, values) {
    return this.intlService.formatMessage(id, values);
  }
  resolveKey(_id, values) {
    var _a, _b;
    const id = (_b = (_a = this.keyResolver) == null ? void 0 : _a.resolve(_id, values)) != null ? _b : _id;
    if (!id) {
      return "Invalid translation";
    }
    return id;
  }
  getTranslationMetaData(id, values) {
    const variables = [];
    const tags = [];
    Object.entries(values != null ? values : {}).forEach(([key, value]) => {
      if (typeof value === "function") {
        tags.push(key);
      } else {
        variables.push(key);
      }
    });
    return {
      key: id,
      variables: variables.join(", "),
      tags: tags.join(", ")
    };
  }
}
function getTimeZone$1() {
  const dtf = new Intl.DateTimeFormat();
  const options = dtf.resolvedOptions();
  return options.timeZone;
}
var GeoEnvironment;
(function(GeoEnvironment2) {
  GeoEnvironment2[GeoEnvironment2["Hq"] = 0] = "Hq";
  GeoEnvironment2[GeoEnvironment2["Us"] = 1] = "Us";
  GeoEnvironment2[GeoEnvironment2["Local"] = 2] = "Local";
})(GeoEnvironment || (GeoEnvironment = {}));
class EnvDetectionService {
  constructor(timeZoneResolver) {
    Object.defineProperty(this, "timeZoneResolver", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "cachedEnv", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    this.timeZoneResolver = timeZoneResolver;
    this.cachedEnv = null;
  }
  detect() {
    var _a;
    if (this.cachedEnv !== null) {
      return this.cachedEnv;
    }
    this.cachedEnv = ((_a = this.timeZoneResolver()) === null || _a === void 0 ? void 0 : _a.startsWith("Europe")) ? GeoEnvironment.Hq : GeoEnvironment.Us;
    return this.cachedEnv;
  }
}
let envDetectionService = null;
function detectGeoEnvironment() {
  if (envDetectionService === null) {
    envDetectionService = new EnvDetectionService(getTimeZone$1);
  }
  return envDetectionService.detect();
}
function applyTranslationsVariables(_translations, variables) {
  if (variables.size === 0) {
    return _translations;
  }
  const translations = __spreadValues({}, _translations);
  const variablesArray = Array.from(variables);
  for (const key in translations) {
    if (!Object.hasOwnProperty.call(translations, key)) {
      continue;
    }
    let value = translations[key];
    for (const [param, paramValue] of variablesArray) {
      value = value.replace(new RegExp(`\\[\\[${param}]]`, "g"), paramValue);
    }
    translations[key] = value;
  }
  return translations;
}
class TranslationToolsService {
  static create(getTranslation, onVersionChange, onOverlayChange) {
    if (!globalThis.TranslationTools) {
      globalThis.TranslationTools = new TranslationTools(getTranslation);
      if (onVersionChange) {
        globalThis.TranslationTools.Versions.subscribe(onVersionChange);
      }
      if (onOverlayChange) {
        globalThis.TranslationTools.Overlay.subscribe(onOverlayChange);
      }
    }
  }
  static destroy() {
    if (globalThis.TranslationTools) {
      globalThis.TranslationTools = void 0;
    }
  }
}
function isBrowser() {
  return typeof window === "object";
}
class TranslationsService {
  constructor(config = {}) {
    __publicField(this, "config", {
      apiUrl: `https://ts.getresponse.${detectGeoEnvironment() === GeoEnvironment.Us ? "com" : "pl"}/v1/api/translations`,
      storageName: "gr-translations",
      storageStoreName: "translations",
      namespaceSeparator: ".",
      payloadTransformer: (response, data) => {
        var _a;
        return (_a = response[data.locale]) != null ? _a : response;
      },
      queryTransformer: (locale, spaces) => ({ locale, spaces: spaces.join(",") }),
      requestHeaders: {
        Accept: "application/json"
      },
      eTagHeaderName: "Accept-Language",
      locale: "en",
      defaultTimeZoneId: DEFAULT_TIMEZONE_ID,
      useETag: true,
      modernProvider: true,
      variables: new Map()
    });
    __publicField(this, "api");
    __publicField(this, "fetchedSpaces", new Set());
    __publicField(this, "fetchedTranslations", {});
    __publicField(this, "intl");
    __publicField(this, "callbacks", {
      [EventType.INTL_CHANGE]: []
    });
    __publicField(this, "intlCache", new Store());
    __publicField(this, "getTranslation", (key) => {
      return this.fetchedTranslations[key];
    });
    this.setConfig(config);
  }
  setConfig(config) {
    const prevConfig = this.config;
    this.config = __spreadValues(__spreadValues({}, prevConfig), config);
    if (isBrowser() && navigator.cookieEnabled) {
      if (!this.config.modernProvider) {
        TranslationToolsService.destroy();
      }
      if (this.config.modernProvider) {
        TranslationToolsService.create(this.getTranslation, () => this.refresh(), () => this.createIntl());
      }
    }
    const {
      storageName,
      storageStoreName,
      apiUrl,
      requestHeaders,
      eTagHeaderName,
      queryTransformer,
      payloadTransformer,
      locale,
      defaultTimeZoneId,
      useETag,
      modernProvider
    } = this.config;
    const apiConfigHasChange = prevConfig.apiUrl !== apiUrl || prevConfig.requestHeaders !== requestHeaders || prevConfig.eTagHeaderName !== eTagHeaderName || prevConfig.queryTransformer !== queryTransformer || prevConfig.payloadTransformer !== payloadTransformer || prevConfig.modernProvider !== modernProvider || prevConfig.useETag !== useETag;
    if (!this.api || apiConfigHasChange) {
      this.api = new TranslationsApi({
        url: apiUrl,
        defaultHeaders: requestHeaders,
        eTagHeaderName,
        queryTransformer,
        payloadTransformer,
        modernProvider,
        useETag,
        storageConfig: {
          storageName,
          storageStoreName
        }
      });
    }
    if (prevConfig.locale !== locale) {
      this.intlCache.clear();
      this.fetchedSpaces.clear();
      this.fetchedTranslations = {};
    }
    if (!this.intl || prevConfig.locale !== locale || prevConfig.defaultTimeZoneId !== defaultTimeZoneId || prevConfig.keyResolver !== this.config.keyResolver) {
      this.createIntl();
    }
  }
  async fetch(spaces) {
    const { locale } = this.config;
    const spacesToFetch = spaces.filter((space) => !this.fetchedSpaces.has(space));
    if (!this.config.apiUrl) {
      throw new Error("Empty config.apiUrl. To use fetch config.apiUrl is required. Define it first");
    }
    if (spacesToFetch.length === 0) {
      return;
    }
    const requestData = {
      locale,
      spaces: spacesToFetch,
      eTag: this.config.useETag
    };
    const translations = await this.api.fetch(requestData);
    Object.entries(translations).forEach(([space, keys]) => {
      var _a;
      const parsedSpace = (_a = spacesToFetch.find((s) => new SpaceParser(s).getSpace() === space)) != null ? _a : space;
      this.registerTranslations(new SpaceParser(parsedSpace).getKeyWithoutVersion(), keys);
    });
    this.createIntl();
  }
  async refresh() {
    const spaces = Array.from(this.fetchedSpaces);
    this.intlCache.clear();
    this.fetchedSpaces.clear();
    this.fetchedTranslations = {};
    await this.fetch(spaces);
  }
  setTranslations(keys) {
    const keysBySpace = {};
    const separator = this.config.namespaceSeparator;
    for (const [key, value] of Object.entries(keys)) {
      const [space, ...keyParts] = key.split(separator);
      if (!keysBySpace[space]) {
        keysBySpace[space] = {};
      }
      keysBySpace[space][[space, ...keyParts].join(separator)] = value;
    }
    for (const [space, spaceKeys] of Object.entries(keysBySpace)) {
      this.registerTranslations(space, spaceKeys);
    }
    this.createIntl();
  }
  async getStoredSpaceTranslations(spaces) {
    return getSpaces(this.config.locale, spaces, {
      storageName: this.config.storageName,
      storageStoreName: this.config.storageStoreName
    });
  }
  getTranslations() {
    return this.fetchedTranslations;
  }
  getLocale() {
    return this.config.locale;
  }
  on(eventType, callback) {
    this.callbacks[eventType].push(callback);
    return this;
  }
  off(eventType, callback) {
    const index = this.callbacks[eventType].indexOf(callback);
    if (index !== -1) {
      this.callbacks[eventType].splice(index, 1);
    }
    return this;
  }
  fire(eventType) {
    const callbacks = this.callbacks[eventType];
    switch (eventType) {
      case EventType.INTL_CHANGE:
        callbacks.forEach((callback) => callback(this.intl));
        break;
    }
    return this;
  }
  getIntl() {
    return this.intl;
  }
  registerTranslations(space, keys) {
    Object.assign(this.fetchedTranslations, applyTranslationsVariables(keys, this.config.variables));
    this.fetchedSpaces.add(space);
  }
  createIntl() {
    var _a, _b;
    const { locale, defaultTimeZoneId } = this.config;
    this.intl = new TranslationIntl({
      locale,
      defaultTimeZoneId,
      messages: this.fetchedTranslations,
      keyResolver: this.config.keyResolver,
      showKeyInfo: (_b = (_a = getTranslationTools()) == null ? void 0 : _a.Overlay.isOn()) != null ? _b : false
    }, this.intlCache);
    this.fireIntlChangeCallbacks();
  }
  fireIntlChangeCallbacks() {
    this.fire(EventType.INTL_CHANGE);
  }
  hasTranslationKey(key) {
    return this.fetchedTranslations.hasOwnProperty(key);
  }
}
const defaultTranslationsService = new TranslationsService();
const attachKey = (chunk, index) => {
  if (React.isValidElement(chunk)) {
    return React.cloneElement(chunk, { key: chunk.key || index });
  }
  return chunk;
};
const r = /&\S*?;/;
let e = null;
function o(t) {
  var n;
  return r.test(t) ? (n = (e != null ? e : e = new DOMParser()).parseFromString(t, "text/html").documentElement.textContent) != null ? n : "" : t;
}
function renderChunk(chunk, index) {
  if (Array.isArray(chunk)) {
    return chunk.map(renderChunk);
  }
  if (React.isValidElement(chunk)) {
    return attachKey(chunk, index);
  }
  if (typeof chunk === "string") {
    return o(chunk);
  }
  return chunk;
}
const TranslationContainer = (_a) => {
  var _b = _a, {
    children
  } = _b, props = __objRest(_b, [
    "children"
  ]);
  return /* @__PURE__ */ React.createElement("span", __spreadValues({}, props), children);
};
const voidElements = ["br"];
const availableConverters = ["br", "strong", "ul", "li", "mark", "sup", "h1", "h2", "h3", "p", "ol"];
const baseConverter = (name, props = {}, chunks = []) => {
  if (voidElements.includes(name)) {
    return React.createElement(name);
  }
  return React.createElement(name, props, chunks.map(renderChunk));
};
const defaultElementConverters = availableConverters.reduce((result, name) => __spreadProps(__spreadValues({}, result), {
  [name]: voidElements.includes(name) ? baseConverter(name) : (...chunks) => baseConverter(name, {}, chunks)
}), {});
function mergeElementConverters(converters = {}, elements = defaultElementConverters) {
  return Object.keys(converters).reduce((result, name) => __spreadProps(__spreadValues({}, result), {
    [name]: converters[name]
  }), elements);
}
function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
}
function useTranslateWithPossibleNull() {
  return useContext(TranslationProviderContext);
}
function useTranslations() {
  const context = useTranslateWithPossibleNull();
  if (context) {
    return context;
  }
  throw new Error("Missing Translation Provider");
}
const defaultContextValue = isBrowser() ? {
  elementConverters: defaultElementConverters,
  container: TranslationContainer,
  intl: defaultTranslationsService.getIntl(),
  translations: defaultTranslationsService
} : null;
const TranslationProviderContext = React.createContext(defaultContextValue);
function Provider({
  elements,
  children,
  messages,
  locale,
  apiUrl,
  defaultTimeZone,
  translationsService = defaultTranslationsService
}) {
  const highOrderContext = useTranslateWithPossibleNull();
  const config = useMemo(() => {
    var _a, _b;
    const partialConfig = {};
    if (locale) {
      partialConfig.locale = locale;
    }
    if (apiUrl) {
      partialConfig.apiUrl = apiUrl;
    }
    if (defaultTimeZone) {
      partialConfig.defaultTimeZoneId = (_b = (_a = timeZones.find((tz) => tz.name === defaultTimeZone)) == null ? void 0 : _a.id) != null ? _b : DefaultTimeZoneId;
    }
    return Object.keys(partialConfig).length ? partialConfig : void 0;
  }, [locale, apiUrl, defaultTimeZone]);
  if (config !== usePrevious(config) && config) {
    translationsService.setConfig(config);
  }
  if (messages !== usePrevious(messages) && messages) {
    translationsService.setTranslations(messages);
  }
  const [intl, setIntl] = React.useState(() => translationsService.getIntl());
  const contextValue = React.useMemo(() => {
    var _a, _b;
    return {
      elementConverters: mergeElementConverters(elements == null ? void 0 : elements.elementConverters, highOrderContext == null ? void 0 : highOrderContext.elementConverters),
      container: (_b = (_a = highOrderContext == null ? void 0 : highOrderContext.container) != null ? _a : elements == null ? void 0 : elements.container) != null ? _b : TranslationContainer,
      intl,
      translations: translationsService
    };
  }, [elements, intl, highOrderContext, translationsService]);
  React.useEffect(() => {
    translationsService.on(EventType.INTL_CHANGE, setIntl);
    setIntl(translationsService.getIntl());
    return () => {
      translationsService.off(EventType.INTL_CHANGE, setIntl);
    };
  }, [translationsService]);
  return /* @__PURE__ */ React.createElement(TranslationProviderContext.Provider, {
    value: contextValue
  }, children);
}
const TranslationProvider = memo$1(Provider);
function isObjectEqual(a, b) {
  if (Object.is(a, b)) {
    return true;
  }
  if (!a || !b) {
    return false;
  }
  const keys = Object.keys(a);
  if (Object.keys(b).length !== keys.length) {
    return false;
  }
  for (const key of keys) {
    if (a[key] !== b[key] || !Object.prototype.hasOwnProperty.call(b, key)) {
      return false;
    }
  }
  return true;
}
function isMessagePropsEqual(prevProps, nextProps) {
  const _a = prevProps, { values } = _a, otherProps = __objRest(_a, ["values"]);
  const _b = nextProps, { values: nextValues } = _b, nextOtherProps = __objRest(_b, ["values"]);
  return isObjectEqual(nextValues, values) && isObjectEqual(otherProps, nextOtherProps);
}
function useIntl() {
  const context = useTranslations();
  if (context) {
    return context.intl;
  }
  throw new Error("Missing Intl Provider");
}
const Message = (props) => {
  const intl = useIntl();
  const { id, values, children, as: Component = React.Fragment } = props;
  const nodes = intl.translate(id, values);
  return /* @__PURE__ */ React.createElement(Component, null, children(...Array.isArray(nodes) ? nodes : [nodes]));
};
const MessageIntl = memo$1(Message, isMessagePropsEqual);
class Translation extends React.Component {
  render() {
    return /* @__PURE__ */ React.createElement(TranslationWithContext, __spreadValues({}, this.props));
  }
}
class TranslationWithContext extends React.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "renderMessage", (...chunks) => {
      var _b;
      const _a = this.props, { id, values, className, innerRef, Container } = _a, otherProps = __objRest(_a, ["id", "values", "className", "innerRef", "Container"]);
      const ContainerComponent = Container || ((_b = this.context) == null ? void 0 : _b.container) || TranslationContainer;
      return /* @__PURE__ */ React.createElement(ContainerComponent, __spreadValues({
        className,
        ref: innerRef
      }, otherProps), chunks.map(renderChunk));
    });
  }
  render() {
    var _a, _b;
    const { id, values } = this.props;
    const elementConverters = (_b = (_a = this.context) == null ? void 0 : _a.elementConverters) != null ? _b : defaultElementConverters;
    return /* @__PURE__ */ React.createElement(MessageIntl, {
      id,
      values: __spreadValues(__spreadValues({}, elementConverters), values)
    }, this.renderMessage);
  }
}
__publicField(TranslationWithContext, "contextType", TranslationProviderContext);
__publicField(TranslationWithContext, "defaultProps", {
  values: {}
});
const IntlProvider = TranslationProvider;
const FormattedCurrency = (props) => {
  const _a = props, { value, currency } = _a, options = __objRest(_a, ["value", "currency"]);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, defaultTranslationsService.getIntl().formatCurrency(value, currency, options));
};
function DateTime(props) {
  const _a = props, { value, format = DateFormat.FULL_DATE_SHORT, timeZone } = _a, otherProps = __objRest(_a, ["value", "format", "timeZone"]);
  return /* @__PURE__ */ React.createElement("span", __spreadValues({}, otherProps), defaultTranslationsService.getIntl().formatDate(value, { format, timeZone }));
}
class FormattedNumber extends React.PureComponent {
  render() {
    const _a = this.props, { value, format } = _a, otherProps = __objRest(_a, ["value", "format"]);
    return /* @__PURE__ */ React.createElement("span", __spreadValues({}, otherProps), defaultTranslationsService.getIntl().formatNumber(value, format));
  }
}
__publicField(FormattedNumber, "defaultProps", {
  format: NumberFormat.ShortFormat
});
var Currency;
(function(Currency2) {
  Currency2["AFN"] = "AFN";
  Currency2["EUR"] = "EUR";
  Currency2["ALL"] = "ALL";
  Currency2["DZD"] = "DZD";
  Currency2["USD"] = "USD";
  Currency2["AOA"] = "AOA";
  Currency2["XCD"] = "XCD";
  Currency2["ARS"] = "ARS";
  Currency2["AMD"] = "AMD";
  Currency2["AWG"] = "AWG";
  Currency2["AUD"] = "AUD";
  Currency2["AZN"] = "AZN";
  Currency2["BSD"] = "BSD";
  Currency2["BHD"] = "BHD";
  Currency2["BDT"] = "BDT";
  Currency2["BBD"] = "BBD";
  Currency2["BYN"] = "BYN";
  Currency2["BZD"] = "BZD";
  Currency2["XOF"] = "XOF";
  Currency2["BMD"] = "BMD";
  Currency2["INR"] = "INR";
  Currency2["BTN"] = "BTN";
  Currency2["BOB"] = "BOB";
  Currency2["BOV"] = "BOV";
  Currency2["BAM"] = "BAM";
  Currency2["BWP"] = "BWP";
  Currency2["NOK"] = "NOK";
  Currency2["BRL"] = "BRL";
  Currency2["BND"] = "BND";
  Currency2["BGN"] = "BGN";
  Currency2["BIF"] = "BIF";
  Currency2["CVE"] = "CVE";
  Currency2["KHR"] = "KHR";
  Currency2["XAF"] = "XAF";
  Currency2["CAD"] = "CAD";
  Currency2["KYD"] = "KYD";
  Currency2["CLP"] = "CLP";
  Currency2["CLF"] = "CLF";
  Currency2["CNY"] = "CNY";
  Currency2["COP"] = "COP";
  Currency2["COU"] = "COU";
  Currency2["KMF"] = "KMF";
  Currency2["CDF"] = "CDF";
  Currency2["NZD"] = "NZD";
  Currency2["CRC"] = "CRC";
  Currency2["HRK"] = "HRK";
  Currency2["CUP"] = "CUP";
  Currency2["CUC"] = "CUC";
  Currency2["ANG"] = "ANG";
  Currency2["CZK"] = "CZK";
  Currency2["DKK"] = "DKK";
  Currency2["DJF"] = "DJF";
  Currency2["DOP"] = "DOP";
  Currency2["EGP"] = "EGP";
  Currency2["SVC"] = "SVC";
  Currency2["ERN"] = "ERN";
  Currency2["ETB"] = "ETB";
  Currency2["FKP"] = "FKP";
  Currency2["FJD"] = "FJD";
  Currency2["XPF"] = "XPF";
  Currency2["GMD"] = "GMD";
  Currency2["GEL"] = "GEL";
  Currency2["GHS"] = "GHS";
  Currency2["GIP"] = "GIP";
  Currency2["GTQ"] = "GTQ";
  Currency2["GBP"] = "GBP";
  Currency2["GNF"] = "GNF";
  Currency2["GYD"] = "GYD";
  Currency2["HTG"] = "HTG";
  Currency2["HNL"] = "HNL";
  Currency2["HKD"] = "HKD";
  Currency2["HUF"] = "HUF";
  Currency2["ISK"] = "ISK";
  Currency2["IDR"] = "IDR";
  Currency2["XDR"] = "XDR";
  Currency2["IRR"] = "IRR";
  Currency2["IQD"] = "IQD";
  Currency2["ILS"] = "ILS";
  Currency2["JMD"] = "JMD";
  Currency2["JPY"] = "JPY";
  Currency2["JOD"] = "JOD";
  Currency2["KZT"] = "KZT";
  Currency2["KES"] = "KES";
  Currency2["KPW"] = "KPW";
  Currency2["KRW"] = "KRW";
  Currency2["KWD"] = "KWD";
  Currency2["KGS"] = "KGS";
  Currency2["LAK"] = "LAK";
  Currency2["LBP"] = "LBP";
  Currency2["LSL"] = "LSL";
  Currency2["ZAR"] = "ZAR";
  Currency2["LRD"] = "LRD";
  Currency2["LYD"] = "LYD";
  Currency2["CHF"] = "CHF";
  Currency2["MOP"] = "MOP";
  Currency2["MKD"] = "MKD";
  Currency2["MGA"] = "MGA";
  Currency2["MWK"] = "MWK";
  Currency2["MYR"] = "MYR";
  Currency2["MVR"] = "MVR";
  Currency2["MRU"] = "MRU";
  Currency2["MUR"] = "MUR";
  Currency2["XUA"] = "XUA";
  Currency2["MXN"] = "MXN";
  Currency2["MXV"] = "MXV";
  Currency2["MDL"] = "MDL";
  Currency2["MNT"] = "MNT";
  Currency2["MAD"] = "MAD";
  Currency2["MZN"] = "MZN";
  Currency2["MMK"] = "MMK";
  Currency2["NAD"] = "NAD";
  Currency2["NPR"] = "NPR";
  Currency2["NIO"] = "NIO";
  Currency2["NGN"] = "NGN";
  Currency2["OMR"] = "OMR";
  Currency2["PKR"] = "PKR";
  Currency2["PAB"] = "PAB";
  Currency2["PGK"] = "PGK";
  Currency2["PYG"] = "PYG";
  Currency2["PEN"] = "PEN";
  Currency2["PHP"] = "PHP";
  Currency2["PLN"] = "PLN";
  Currency2["QAR"] = "QAR";
  Currency2["RON"] = "RON";
  Currency2["RUB"] = "RUB";
  Currency2["RWF"] = "RWF";
  Currency2["SHP"] = "SHP";
  Currency2["WST"] = "WST";
  Currency2["STN"] = "STN";
  Currency2["SAR"] = "SAR";
  Currency2["RSD"] = "RSD";
  Currency2["SCR"] = "SCR";
  Currency2["SLL"] = "SLL";
  Currency2["SGD"] = "SGD";
  Currency2["XSU"] = "XSU";
  Currency2["SBD"] = "SBD";
  Currency2["SOS"] = "SOS";
  Currency2["SSP"] = "SSP";
  Currency2["LKR"] = "LKR";
  Currency2["SDG"] = "SDG";
  Currency2["SRD"] = "SRD";
  Currency2["SZL"] = "SZL";
  Currency2["SEK"] = "SEK";
  Currency2["CHE"] = "CHE";
  Currency2["CHW"] = "CHW";
  Currency2["SYP"] = "SYP";
  Currency2["TWD"] = "TWD";
  Currency2["TJS"] = "TJS";
  Currency2["TZS"] = "TZS";
  Currency2["THB"] = "THB";
  Currency2["TOP"] = "TOP";
  Currency2["TTD"] = "TTD";
  Currency2["TND"] = "TND";
  Currency2["TRY"] = "TRY";
  Currency2["TMT"] = "TMT";
  Currency2["UGX"] = "UGX";
  Currency2["UAH"] = "UAH";
  Currency2["AED"] = "AED";
  Currency2["USN"] = "USN";
  Currency2["UYU"] = "UYU";
  Currency2["UYI"] = "UYI";
  Currency2["UZS"] = "UZS";
  Currency2["VUV"] = "VUV";
  Currency2["VEF"] = "VEF";
  Currency2["VND"] = "VND";
  Currency2["YER"] = "YER";
  Currency2["ZMW"] = "ZMW";
  Currency2["ZWL"] = "ZWL";
  Currency2["XBA"] = "XBA";
  Currency2["XBB"] = "XBB";
  Currency2["XBC"] = "XBC";
  Currency2["XBD"] = "XBD";
  Currency2["XTS"] = "XTS";
  Currency2["XXX"] = "XXX";
  Currency2["XAU"] = "XAU";
  Currency2["XPD"] = "XPD";
  Currency2["XPT"] = "XPT";
  Currency2["XAG"] = "XAG";
})(Currency || (Currency = {}));
function setConfig(config) {
  defaultTranslationsService.setConfig(config);
}
async function fetchSpaces(spaces) {
  return defaultTranslationsService.fetch(spaces);
}
function setTranslations(keys) {
  return defaultTranslationsService.setTranslations(keys);
}
function getFetchedTranslations() {
  return defaultTranslationsService.getTranslations();
}
async function getStoredSpaceTranslations(spaces) {
  return defaultTranslationsService.getStoredSpaceTranslations(spaces);
}
function translate(id, values) {
  return defaultTranslationsService.getIntl().translateString(id, values);
}
async function refresh() {
  return defaultTranslationsService.refresh();
}
function getTimeZone() {
  return defaultTranslationsService.getIntl().getTimeZone();
}
function getLocale() {
  return defaultTranslationsService.getLocale();
}
function formatMessage({ id }, values) {
  return translate(id, values);
}
function formatCurrency(value, currency, options) {
  return defaultTranslationsService.getIntl().formatCurrency(value, currency, options);
}
function formatNumber(value, formatOrOptions = {}) {
  return defaultTranslationsService.getIntl().formatNumber(value, formatOrOptions);
}
function formatDate(value, options) {
  return defaultTranslationsService.getIntl().formatDate(value, options);
}
function hasTranslation(key) {
  return defaultTranslationsService.hasTranslationKey(key);
}
export { Currency, DateFormat, DateTime, FormattedCurrency, FormattedNumber, IntlProvider, NumberFormat, Translation, TranslationProvider, TranslationsApi, TranslationsService, attachKey, availableConverters, convertBcpLocaleToGrLocale, convertGrLocaleToBcpLocale, convertGrLocaleToBcpOrFallbackToDefault, defaultElementConverters, fetchSpaces, filterTimeZone, formatCurrency, formatDate, formatMessage, formatNumber, getFetchedTranslations, getLocale, getStoredSpaceTranslations, getTimeZone, getTimeZoneNameById, guessTimeZone, hasTranslation, refresh, renderChunk, setConfig, setTranslations, timeZones, translate, useIntl, useTranslateWithPossibleNull, useTranslations, voidElements };
